<template>
  <div class="wrap">
    <div id="components-box">
      <div class="left">
        <div class="diy-left-side-tab">
          <h3>M Art平台规则</h3>
          <div class="tabs-handler">
            <div class="item" :class="{ active: active === '1' }" @click="change('1')">用户协议</div>

            <div class="item" :class="{ active: active === '2' }" @click="change('2')">隐私政策</div>

            <div class="item" :class="{ active: active === '3' }" @click="change('3')">版权保护申诉指引</div>
            <div class="item" :class="{ active: active === '4' }" @click="change('4')">创作规范</div>
            <div class="item" :class="{ active: active === '5' }" @click="change('5')">美术作品合作协议</div>
          </div>
        </div>
      </div>

      <div class="right">
        <keep-alive>
          <component :is="'tab' + active" class="tab" @changeActive="change"></component>
        </keep-alive>
      </div>
      <div class="right" v-if="false">
        <div v-show="active === '1'">
          <div>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: center;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt; font-weight: bold">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt; font-weight: bold">平台服务协议</span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">首部及导言</span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">欢迎您使用</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">平台提供的服务！</span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">为使用</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >平台服务（以下简称：本服务），您应当阅读并遵守本《服务协议》（以下简称</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">:本协议）以及</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">平台公示的相关规则</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">等</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">法律文件</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >。请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款，以及开通或使用某项服务的单独协议、规则。
                除非您已阅读并接受本协议及相关协</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">议、规则等所有条款，否则，您无权使用</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">提供的本服务。您使用</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >的本服务，即视为您已阅读并同意上述协议、规则等的约束。您有违反本协议的任何行为时，</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">有权依</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >照违反情况，随时单方限制、中止或终止向您提供本服务，并有权追究您的相关责任。</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"> </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">如果您未满</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >18周岁，请在法定监护人的陪同下阅读本协议，并特别注意未成年人使用条款</span
              >
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">1.术语含义</span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">如无特别说明，下列术语在本协议中的含义为：</span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">1.1</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">： 是指</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">公司及其相关服务可能存在的运营关联单位。 </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">1.2投稿人：指经有效注册、申请后，通过</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >平台上传原创或经权利人授权的作品供用户下载使用的个人、法人或其他组织，也简称为“您”。
              </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">1.3授权人：指拥有作品著作权并授权投稿人通过</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">平台上传该作品的个人、法人或其他组织。 </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">1.4普通用户：指拥有作品著作权并授权投稿人通过</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">平台上传该作品的个人、法人或其他组织。 </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">1.5作品：指您或者授权人独立创作的、通过</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >平台上传的原创内容，以及创作过程产生的全部资料、素材（包括但不限于每一幅</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">图片</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >的标题、故事大纲、脚本/台词、角色关系、人物形象、服饰造型、场景等）。</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">本平台中常见的</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">作品的</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">主要指平面美术作品和摄影作品</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">等。</span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">1）</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">平面美术作品</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">：</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >是指绘画、书法等以线条、色彩或者其他方式构成的平面艺术作品。</span
              >
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">2）</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >摄影作品：通过摄影师或业余爱好者通过灵感，摄影技术等对自然、人物等客观事物进行描绘、供人欣赏的艺术作品。</span
              >
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">1.6</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">平台：指由</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">所拥有、控制、经营的</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >平台网站及该网站的下属子页面、APP及H5站等，以下也简称为“</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">平台”、“平台”。</span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">、投稿人均同意和理解：</span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">1）</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >平台作为一个中立的平台，本协议项下仅向投稿人及用户提供作品上传</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">、文化经营</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">服务或相关中立的技术支持服务；</span
              ><span style="font-family: 微软雅黑; font-size: 12pt; text-decoration: underline">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt; text-decoration: underline"
                >平台也不提供编辑、加工、汇编、翻译等出版服务</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">；</span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">2）</span
              ><span style="font-family: 微软雅黑; font-size: 12pt; font-weight: bold; text-decoration: underline"
                >用户</span
              ><span style="font-family: 微软雅黑; font-size: 12pt; font-weight: bold; text-decoration: underline"
                >的作品由</span
              ><span style="font-family: 微软雅黑; font-size: 12pt; font-weight: bold; text-decoration: underline"
                >用户</span
              ><span style="font-family: 微软雅黑; font-size: 12pt; font-weight: bold; text-decoration: underline"
                >或授权人自主创作</span
              ><span style="font-family: 微软雅黑; font-size: 12pt; font-weight: bold; text-decoration: underline"
                >、自主删改、自愿上传、拥有知识产权</span
              ><span style="font-family: 微软雅黑; font-size: 12pt; font-weight: bold; text-decoration: underline"
                >并独立承担全部责任</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">；</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">用户与</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >另行签署书面协议转让其作品著作权的，按照协议约定明确双方的权利和义务。</span
              >
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >3）因投稿人的作品产生的任何纠纷、责任等，以及投稿人违反相关法律法规或本协议约定引发的任何后果，均由投稿人独立承担责任、赔偿损失，与</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">无关。如侵害到</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >或他人权益的，投稿人须自行承担全部责任和赔偿一切损失。
              </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">1.7</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">平台运营数据：指用户、投稿人在使用</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >平台服务中产生的相关数据，包括但不限于用户或投稿人提交的数据、操作行为形成的数据及各类交易数据等。“</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">平台运营数据”的所有权及其他相关权利属于</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">，且是</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">的商业秘密，依法属于用户享有的相关权利除外。 </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">2.投稿人的权利和义务</span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">2.1帐户注册 </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">2.1.1投稿人应当通过登录</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">平台网站或</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >其他指定途径，使用官方指定方式注册投稿人帐户（以下简称：帐户）以成为投稿人，投稿人帐户一经注册成功，相应的账号信息不得变更，且该帐户不可转让、不可赠与、不可继承等。
              </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt"
                >2.1.2您注册帐号时，应使用您拥有合法使用权的账号信息，并遵守相关协议、规则等的约束。
              </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt"
                >2.1.3您不得违反本协议约定将您的帐户用于其他目的。否则，</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >有权随时单方限制、中止或终止向您提供本服务，且未经</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">同意您不得再次使用本服务。 </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt"
                >2.1.4您注册帐号使用的注册信息是您登录及使用本服务的凭证。您应当做好帐号、密码以及进入和管理本服务中的各类功能与服务的口令、密码等的保密措施。因您保密措施不当或您的其他行为，致使上述口令、密码等丢失或泄漏所引起的一切损失和后果，均由您自行承担。
              </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt"
                >2.1.5您保证：您注册本服务帐户时提供和使用的所有个人信息是合法的。前述账号信息在本服务中进行的包括但不限于以下事项：注册本服务帐户、提交相应资质材料、确认和同意相关协议和规则等事项，均是您自行或您授权他人进行的行为，对您均有约束力。同时，您承担以前述账号信息为标识进行的全部行为的法律责任。
              </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt"
                >2.1.6若您发现有他人冒用或盗用您的帐户及密码、或任何其他未经您合法授权的情形时，应立即以有效方式通知</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >（包括但不限于提供您的身份信息和相关身份资料、相关事实情况及您的要求等）。</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >收到您的有效请求并核实身份后，会根据不同情况采取相应措施。若您提供的信息不完全，导致</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">无法核实您的身份或</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">无法判断您的需求等，而导致</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >无法进行及时处理，给您带来的损失，您应自行承担。同时，</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">对您的请求采取措施需要合理期限，在您通知</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">以及</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >根据您的有效通知采取措施之前，由于他人行为给您造成的损失，</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">不承担任何责任</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">。</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"> </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">2.2资质材料 </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt"
                >2.2.1您保证：您如实填写和提交帐号注册与您审核资料，并对资料的真实性、合法性、准确性和有效性承担责任；您提供的主体资质材料、相关资质证明以及其他任何文件等信息真实、准确、完整，并在信息发生变更后，及时进行更新；您具备履行本协议项下之义务、各种行为的能力；您履行相关义务、从事相关行为不违反任何对您有约束力的法律文件。否则，</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >有权拒绝或终止提供本服务，并依照本协议对违规帐号进行处罚，您应独自承担由此带来的一切责任及给第三方、</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">造成的全部损失。 </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">2.2.2您保证：您对在</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">平台上传的作品拥有著作权或已经著作权人授权，</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >有权要求您提供相关权利证明文件、授权文件、相关机构颁发的权利证书等，您应当配合。
              </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">2.2.3您保证：您在</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >平台上传的作品，符合国家相关法规的规定，不违反任何相关法规及相关协议、规则，也不会侵犯任何人的合法权益，同时，</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >有权要求您提供相关权利证明文件、授权文件、相关机构颁发的权利证书等，您应当配合。
              </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">2.2.4您保证：您会依法及按照</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >要求提交使用本服务所必须的真实、准确的主体资质材料以及联系人姓名（名称）、地址、电子邮箱等相关资料。
              </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">2.3投稿人资质审核 </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">2.3.1</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >仅对您提交的资料和信息进行审核，并不对您实际行为承担任何责任或提供任何担保。因您的行为导致与其他用户或第三方发生争议的，由您独立对外承担责任，因此给</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >、其他用户或第三方造成损害的，您应当依法予以赔偿。
              </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">2.3.2为向用户提供更专业的服务，您同意授权</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >可以委托第三方对投稿人所提交的资料进行审核，并根据审核情况进行独立判断后确定审核结果。
              </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">2.4作品要求 </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">2.4.1投稿人应当自行负责您作品的创作、上传及</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">素材交易</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">等工作。 </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt"
                >2.4.2投稿人的作品，应符合相关法规、规范或标准等，同时，还应符合</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">平台的对作品制作与上传等方面的统一要求，如《</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                ><a style="color: blue" @click="active = '4'">创作规范</a> </span
              ><span style="font-family: 微软雅黑; font-size: 12pt">》及其他相关规则。 </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt"
                >2.4.3投稿人的作品不应侵犯任何人的合法权益，包括但不限于著作权、商标权、肖像权、名誉权、姓名权等。
              </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">2.4.4基于维护</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >平台其他用户的合法权益以及保障作品发布、阅读的稳定性，如果您考虑下架您自行上传的作品，应当提前以有效方式通知</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">，并与</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >共同友好商议处理方案。若您违反上述约定擅自下架作品，则由此导致的用户投诉、争议等，应当由您自行承担责任并独立解决；若给</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">造成相应损失的，还应当负责赔偿。同时，</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">还有权要求您退还基于使用</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">平台服务取得的全部收益。若您与</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >另行签署其他相关书面协议，则以该书面协议的约定为准。
              </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">2.5</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">上传、</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">作品</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">展示、素材交易等行为</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"> </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">2.5.1您应自行按照相关法规，</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">上传</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >您的作品，履行相关义务，并自行承担全部责任，包括但不限于：
              </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">1）依照相关法律法规的规定，规范线上线下作品的</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">创作、上传、素材交易等</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">行为； </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >2）国家有权机关向您依法查询相关信息时，应积极配合提供；</span
              >
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">3）您应依法主动履行的其他义务。 </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt"
                >2.5.2您不得从事任何包括但不限于以下违规行为，也不得为以下违规行为提供便利：
              </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">1）反对宪法所确定的基本原则的行为； </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的行为；
              </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">3）损害国家荣誉和利益的行为； </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >4）煽动民族仇恨、民族歧视，破坏民族团结的行为；
              </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >5）破坏国家宗教政策，宣扬邪教和封建迷信的行为；
              </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >6）散布谣言，扰乱社会秩序，破坏社会稳定的行为；
              </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >7）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的行为；
              </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >8）侮辱或者诽谤他人，侵害他人合法权益的行为；
              </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >9）侵害他人知识产权、商业秘密等合法权利的行为；
              </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >10）恶意虚构事实、隐瞒真相以误导、欺骗他人的行为；
              </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">11）发布、传送、传播广告信息及垃圾信息； </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">12）其他法律法规禁止的行为。 </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt"
                >2.5.3您不得从事包括但不限于以下行为，也不得为以下行为提供便利：
              </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">1）删除、隐匿、改变</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >平台显示或其中包含的任何专利、著作权、商标或其他所有权声明；
              </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">2）以任何方式干扰或企图干扰</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >任何产品、任何部分或功能的正常运行，或者制作、发布、传播上述工具、方法等；
              </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >3）避开、尝试避开或声称能够避开任何内容保护机制，或导致用户认为其直接与</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">平台及</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">相关产品进行交互； </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">4）在未获得</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">书面许可的情况下，以任何方式使用</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">URL地址、技术接口等；</span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >5）在未经过用户同意的情况下，向任何其他用户及他方显示或以其他任何方式提供该用户的任何信息；
              </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">6）在未获得</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >书面许可的情况下，请求、收集、索取或以其他方式获取用户</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">关于本平台的账号，以及</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">QQ、微信等帐号、密码或其他任何身份验证凭据； </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">7）为任何用户自动登录到</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">平台提供代理身份验证凭据； </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >8）提供跟踪功能，包括但不限于识别其他用户在个人主页上查看、点击等操作行为；
              </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">9）自动将浏览器窗口定向到其他网页； </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">10）未经授权获取对</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">产品或服务的访问权； </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >11）应用中含有计算机病毒、木马或其他恶意程序等任何可能危害</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">或用户权益和终端信息安全等的内容； </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >12）设置或发布任何违反相关法规、公序良俗、社会公德等的功能或内容等；
              </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">13）公开表达或暗示，您与</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >之间存在合作关系，包括但不限于相互持股、商业往来或合作关系等，或声称</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">对您的认可； </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >14）填写和提交帐号注册与投稿人审核资料违反本协议规定，或申请投稿人审核资料与注册信息内容不一致，以及运营行为与注册或投稿人认证信息所公示身份无关的；
              </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">15）若您确认上传的作品性质为“独家”，则在未获得</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">书面许可的情况下，您不得将发表于</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">平台的作品在其他第三方网站、平台发表； </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >16）公开表达或暗示，宣传第三方动漫网站、应用、产品或其他未经</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >授权之个人、企业、工作室等的任何内容（包括但不限于商标、Logo、企业字号、作者/作品信息等）；
              </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">17）其他</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >认为不应该、不适当的行为、内容。本服务中可能会使用第三方软件或技术，若有使用，</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">保证已经获得合法授权，同时，</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >将按照相关法规或约定，对相关的协议或其他文件，进行展示。前述通过各种形式展现的相关协议或其他文件，均是本协议不可分割的组成部分，与本协议具有同等的法律效力，您应当遵守这些要求。否则，因此带来的一切责任您应自行承担。如因本服务使用的第三方软件或技术引发的任何纠纷，由该第三方负责解决。
              </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">2.6关于用户数据的规则 </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt"
                >2.6.1在未获得其他用户同意的情况下，您不得收集用户的隐私信息数据及其他</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >认为属于敏感信息范畴的数据，包括但不限于不得收集或要求用户提供任何</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">账号</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >、密码、用户关系链、好友列表数据、银行账号和密码等。基于本款约定产生的法律责任，由您自行向其他用户或其他主体承担。
              </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">2.6.2</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">有权限制或阻止您获取用户数据及</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">平台数据。 </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">2.6.3</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">平台运营数据、用户数据等数据的全部权利，均归属</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">，且是</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >的商业秘密，依法属于用户享有的相关权利除外。未经</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >事先书面同意，您不得为本协议约定之外的目的使用前述数据，亦不得以任何形式将前述数据提供给他人。
              </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">2.6.4一旦您停止使用本服务，或停止使用</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">平台，或</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >基于任何原因终止您使用本服务，您必须立即删除全部从</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >平台中获得的数据（包括各种备份），且不得再以任何方式进行使用。您理解并同意，本款约定情况下不得擅自下架作品。基于维护</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >平台其他用户的合法权益以及保障作品发布、阅读的稳定性，您应当与</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">共同友好商议处理方案；且除您与</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >达成一致意见外，您基于本款约定停止使用本服务的情况下，不影响已发布作品在</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">平台的继续连载、使用，且不视为</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >侵权。若由此导致其他用户的投诉等，应当由您自行承担</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">责任并独立解决；若给</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">造成相应损失的，还应当负责赔偿。同时，</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">还有权要求您退还基于使用</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">平台服务取得的全部收益。若您与</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >另行签署其他相关书面协议，则以该书面协议的约定为准。</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"> </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">2.6.5您应自行对因使用本服务而存储在</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >服务器的各类数据等信息，在本服务之外，采取合理、安全的技术措施，确保其安全性，并对自己的行为（包括但不限于自行安装软件、采取加密措施或进行其他安全措施等）所引起的结果承担全部责任。
              </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">2.7法律责任 </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt"
                >2.7.1您保证：您使用本服务及您的任何行为，不会侵犯任何人的合法权益等。
              </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">2.7.2您理解并同意：若</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >自行发现或根据相关部门的信息、权利人的投诉等发现您可能存在侵犯他人合法权益情形的，</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >有权根据一般人的认识自己进行独立判断，以认定您是否存在侵犯他人合法权益情形，若</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">经过判断认为您存在侵犯他人合法权益情形的，</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">有权随时单方采取以下一项或多项措施： </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >1）要求您立即更换、修改前述侵权作品的相关内容；</span
              >
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">2）对存在违反前述保证情形的部分或全部</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">作品内容章节</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">、图片或者您名下的</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">其他</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">作品采取限制用户使用等措施； </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >3）对存在侵犯他人合法权益的作品采取下架措施，直至终止您使用</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">平台的服务； </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">4）追究您的法律责任； </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">5）将您的行为对外予以公告； </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">6）其他</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">认为适合的处理措施。 </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt"
                >对于侵犯他人合法权益的作品，假设您对该作品进行修改后不再侵犯他人的合法权益，您同意</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >仍然有权对修改后的作品进行下架处理。同时，若有需要，您可以将修改后的不再侵犯他人合法权益的作品作为新作品按照</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">平台的流程、规范等重新向</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">平台投稿。</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"> </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt"
                >2.7.3您保证：您使用本服务及您的任何行为，不违反任何相关法规、本协议和相关协议、规则等。否则，您理解并同意：若</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >自行发现或根据相关部门的信息、权利人的投诉等发现您可能存在违反前述保证情形的，</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >有权根据一般人的认识自己独立判断，以认定您是否存在违反前述保证情形，若</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">经过判断认为您存在违反前述保证情形的，</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">有权随时单方采取以下一项或多项措施。 </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >1）要求您立即更换、修改违反前述保证情形的相关内容；
              </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">2）对存在违反前述保证情形的部分或全部</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">作品内容</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >章节、图片或者您名下的全部作品采取限制用户使用等措施；
              </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >3）对存在侵犯他人合法权益的作品采取下架措施，直至终止您使用</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">平台的服务； </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">4）禁止您今后将您的任何新作品上传至</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">平台； </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">5）追究您的法律责任； </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">6）将您的行为对外予以公告； </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">7）其他</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">认为适合的处理措施。 </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">2.7.4若</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >按照上述条款、本协议的其他相关约定或因您违反相关法律的规定，对您或您的作品采取任何行为或措施，所引起的纠纷、责任等一概由您自行负责，造成您损失的，您应自行全部承担，造成</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">或他人损失的，您也应自行承担全部责任。 </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">3.普通用户的权利和义务</span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt"
                >3.1用户在注册帐号或使用本服务的过程中，可能需要填写一些必要的信息。若国家法律法规有特殊规定的，用户需要填写真实的身份信息。若用户填写的信息不完整，则无法使用本服务或在使用过程中受到限制。</span
              >
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt"
                >3.2一般情况下，用户可以随时浏览、修改自己提交的信息，但出于安全性和身份识别（如号码申诉服务）的考虑，用户可能无法修改注册时提供的初始注册信息及其他验证信息。
              </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">3.3用户知悉并确认，</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >将运用各种安全技术和程序建立完善的管理制度来保护用户的个人信息，以免遭受未经授权的访问、使用或披露。
              </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">3.4</span
              ><span style="font-family: 微软雅黑; font-size: 12pt; font-weight: bold; text-decoration: underline"
                >若用户是18周岁以下的未成年人，在使用</span
              ><span style="font-family: 微软雅黑; font-size: 12pt; font-weight: bold; text-decoration: underline"
                >M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt; font-weight: bold; text-decoration: underline"
                >的服务前，应事先取得用户家长或法定监护人（以下简称"监护人"）的书面同意。</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"> </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt"
                >3.5用户在使用本服务时须遵守国家法律法规及政策规定，不得利用本服务从事任何违法违规行为，包括但不限于：
              </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >1）发布、传送、传播、储存危害国家安全统一、破坏社会稳定、违反公序良俗、侮辱、诽谤、淫秽、暴力以及任何违反国家法律法规的内容；
              </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >2）发布、传送、传播、储存侵害他人知识产权、商业秘密等合法权利的内容；
              </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">3）恶意虚构事实、隐瞒真相以误导、欺骗他人 </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">4）发布、传送、传播广告信息及垃圾信息； </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">5）其他法律法规禁止的行为。 </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt"
                >3.6如果用户违反了本条约定，相关国家机关或机构可能会对您提起诉讼、罚款或采取其他制裁措施，并要求</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">给予协助。造成损害的，用户应依法予以赔偿，</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">不承担任何责任。 </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">3.7如果</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">发现或收到他人举报用户发布的信息违反本条约定，</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >有权进行独立判断并采取技术手段予以删除、屏蔽或断开链接。同时，</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >有权视用户的行为性质，采取包括但不限于暂停或终止服务，限制、冻结或终止</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">账号</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">使用，追究法律责任等措施。 </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt"
                >3.8用户违反本条约定，导致任何第三方损害的，用户应当独立承担责任并自行解决；</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">因此遭受损失的，您也应当一并赔偿。 </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">4.</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">的权利义务</span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">4.1保护您及用户的信息的安全是</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">的一项基本原则，未经您及用户的同意，</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">不会向</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >以外的任何公司、组织和个人披露、提供您的信息，但下列情形除外：</span
              >
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >1）据本协议或其他相关协议、规则等约定可以提供的；
              </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">2）依据法律法规的规定可以提供的； </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">3）行政、司法等政府部门要求提供的； </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">4）您同意</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">向第三方提供； </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">5）为解决举报事件、提起诉讼而需要提供的； </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >6）为防止严重违法行为或涉嫌犯罪行为发生而采取必要合理行动所必须提供的。
              </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">4.2尽管</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >对您及用户的信息保护做了极大的努力，但是仍然不能保证在现有的安全技术措施下，您及用户的信息可能会因为不可抗力或非</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >因素造成泄漏、窃取等，由此给您及用户造成损失的，您及用户同意</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">可以免责。</span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">4.3</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">有权开发、运营与您作品相似或相竞争的作品，同时</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">也不保证</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >平台上不会出现其他投稿人提供的与您的作品相竞争的作品。
              </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">4.4</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >有权在包括但不限于作品介绍、下载页面等，向用户阐述该作品为您上传以及由您向用户提供客户服务等。
              </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">4.5</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >可将本协议下的权利和义务的部分或全部转让给他人，您如果不同意</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >的该转让，则有权停止使用本协议下的服务。否则，视为您对此予以接受。
              </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">4.6除了另行有约定外，</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >无需为按照本协议享有的权益而向您及用户支付任何费用。
              </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt; font-weight: normal">4.7</span
              ><span style="font-family: 微软雅黑; font-size: 12pt; font-weight: bold; text-decoration: underline"
                >您理解并同意：为向更多互联网使用者推广您的作品，</span
              ><span style="font-family: 微软雅黑; font-size: 12pt; font-weight: bold; text-decoration: underline"
                >M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt; font-weight: bold; text-decoration: underline"
                >有权采取以下行为，而无须再取得您的同意：</span
              >
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt; font-weight: bold; text-decoration: underline"
                >（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt; font-weight: bold; text-decoration: underline"
                >1）在</span
              ><span style="font-family: 微软雅黑; font-size: 12pt; font-weight: bold; text-decoration: underline"
                >M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt; font-weight: bold; text-decoration: underline"
                >平台以外的平台、网站等采取各种形式对作品进行宣传、推广；
              </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt; font-weight: bold; text-decoration: underline"
                >（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt; font-weight: bold; text-decoration: underline"
                >2）</span
              ><span style="font-family: 微软雅黑; font-size: 12pt; font-weight: bold; text-decoration: underline"
                >M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt; font-weight: bold; text-decoration: underline"
                >可根据整体运营安排，自主选择向整个或部分全球范围内的互联网用户提供您的作品服务，但您与</span
              ><span style="font-family: 微软雅黑; font-size: 12pt; font-weight: bold; text-decoration: underline"
                >M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt; font-weight: bold; text-decoration: underline"
                >签署的其他书面协议另有约定的除外；
              </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt; font-weight: bold; text-decoration: underline"
                >（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt; font-weight: bold; text-decoration: underline"
                >3）为宣传、推广作品，</span
              ><span style="font-family: 微软雅黑; font-size: 12pt; font-weight: bold; text-decoration: underline"
                >M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt; font-weight: bold; text-decoration: underline"
                >可根据</span
              ><span style="font-family: 微软雅黑; font-size: 12pt; font-weight: bold; text-decoration: underline"
                >M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt; font-weight: bold; text-decoration: underline"
                >平台的功能设计使用您作品的标题、名称、人物形象、构想、图片等相关素材，或为用户提供不限于聊天场景内的、更丰富的作品使用场景。
              </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">5.用户信息收集、使用及保护</span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">5.1您同意并授权</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >为履行本协议之目的收集您及用户的信息，这些信息包括您及用户在注册系统中注册的信息、您及用户账号下的数据以及其他您及用户在使用本服务的过程中向</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">提供或</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">基于安全、用户体验优化等考虑而需收集的信息，</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">对您及用户的信息的收集将遵循相关法律规定。 </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">5.2您及用户充分理解并同意：</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >或其合作的第三方可以根据您及用户的信息，通过短信、电话、邮件等各种方式向您及用户提供关于</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">的活动信息、推广信息等各类信息。 </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">5.3保护用户信息及隐私是</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >的一项基本原则。除本协议另有规定外，本服务对用户信息收集、使用及保护等将遵循</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">统一公布的相关隐私政策。 </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">6.收费服务</span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">6.1</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >的部分服务是以收费方式提供的，如您及用户使用收费服务，请遵守相关的协议、
              </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">6.2</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >可能根据实际需要对收费服务的收费标准、方式进行修改和变更，</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >也可能会对部分免费服务开始收费。前述修改、变更或开始收费前，</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >将在相应服务页面进行通知或公告。如果您及用户不同意上述修改、变更或付费内容，请及时停止使用该服务。
              </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">7.关于免责</span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">7.1您及用户理解并同意：鉴于网络服务的特殊性，</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">有权在无需通知您及用户的情况下根据</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >平台的整体运营情况或相关运营规范、规则等，可以随时变更、中止或终止部分或全部的服务，若由此给您及用户造成损失的，您及用户同意放弃追究</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">的责任。 </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt"
                >7.2您及用户理解并同意：为了向您及用户提供更完善的服务，</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >有权定期或不定期地对提供本服务的平台或相关设备进行检修、维护、升级等，此类情况可能会造成相关服务在合理时间内中断或暂停的，若由此给您及用户造成损失的，您及用户同意放弃追究</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">的责任。 </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">7.3您及用户理解并同意：</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >的服务是按照现有技术和条件所能达到的现状提供的。</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >会尽最大努力向您及用户提供服务，确保服务的连贯性和安全性；但</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >不能保证其所提供的服务毫无瑕疵，也无法随时预见和防范法律、技术以及其他风险，包括但不限于不可抗力、病毒、木马、黑客攻击、系统不稳定、第三方服务瑕疵、政府行为等原因可能导致的服务中断、数据丢失以及其他的损失和风险。所以您及用户也同意：即使</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >提供的服务存在瑕疵，但上述瑕疵是当时行业技术水平所无法避免的，其将不被视为</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >违约，同时，由此给您及用户造成的数据或信息丢失等</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">损失的，您及用户同意放弃追究</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">的责任。</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"> </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt"
                >7.4您及用户理解并同意：在使用本服务的过程中，可能会遇到不可抗力等风险因素，使本服务发生中断。不可抗力是指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、瘟疫流行和风暴等以及社会事件如战争、动乱、政府行为等。出现上述情况时，</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >将努力在第一时间与相关单位配合，及时进行修复，若由此给您及用户造成损失的，您及用户同意放弃追究</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">的责任。 </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">7.5您及用户理解并同意：第三方在</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >平台中投放的广告、链接或者其它形式的宣传推广内容，均是由其自行提供的，您及用户应当自行判断其真实性，</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">对其推广内容不作任何明示或者默示的担保。 </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt"
                >7.6您及用户理解并同意：若由于对以下情形导致的服务中断或受阻，给您及用户造成损失的，您及用户同意放弃追究</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">的责任： </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >1）受到计算机病毒、木马或其他恶意程序、黑客攻击的破坏；
              </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">2）您及用户或</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">的电脑软件、系统、硬件和通信线路出现故障； </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">3）您及用户操作不当； </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">4）您及用户通过非</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">授权的方式使用本服务； </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">5）其他</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">无法控制或合理预见的情形。 </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">8.服务的中止或终止</span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">8.1如您及用户书面通知</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">不接受本协议或对其的修改，</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">有权随时中止或终止向您及用户提供本服务。 </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt"
                >8.2因不可抗力因素导致您及用户无法继续使用本服务或</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">无法提供本服务的，</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">有权随时终止协议。 </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">8.3本协议约定的其他中止或终止条件发生或实现的，</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">有权随时中止或终止向您及用户提供本服务。 </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">8.4由于您及用户违反本协议约定，</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >依约终止向您及用户提供本服务后，如您及用户后续再直接或间接或以他人名义注册使用本服务的，</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">有权单方面暂停或终止提供本服务。 </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt"
                >8.5如本协议或本服务因为任何原因终止的，对于您及用户的帐号中的全部数据或您及用户因使用本服务而存储在</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">服务器中的数据等任何信息，</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >可将该等信息保留或删除，包括服务终止前您及用户尚未完成的任何数据。
              </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt"
                >8.6如本协议或本服务因为任何原因终止的，您及用户应自行处理好关于数据等信息的备份以及与您的用户之间的相关事项的处理等，由此造成</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">损失的，您及用户应负责赔偿。 </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt"
                >8.7用户在本协议或本服务有效期内下载的作品，用户可永久使用。本协议或本服务的终止不影响用户对已下载作品的使用。
              </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">9.关于通知</span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">9.1</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >可能会以一种或多种不同的方式（包括但不限于网页公告、网页提示、电子邮箱、手机短信、常规的信件传送、您及用户注册的本服务帐号的管理系统内发送站内信等）向您及用户送达关于本服务的各种规则、通知、提示等信息，该等信息一经</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >采取前述任何一种方式公布或发送，即视为您及用户已经接受并同意，对您及用户产生约束力。若您及用户不接受的，请您及用户书面通知</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">，否则视为您及用户已经接受、同意。 </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt"
                >9.2若由于您及用户提供的电子邮箱、手机号码、通讯地址等信息错误，导致您及用户未收到相关规则、通知、提示等信息的，您及用户同意仍然视为您及用户已经收到相关信息并受其约束，一切后果及责任由您及用户自行承担。
              </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">9.3您及用户也同意</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >或合作伙伴可以向您及用户的电子邮件、手机号码等发送可能与本服务不相关的其他各类信息包括但不限于商业广告等。
              </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">9.4若您及用户有事项需要通知</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >的，应当按照本服务对外正式公布的联系方式书面通知</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">。 </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">10.知识产权</span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">10.1</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >在本服务中提供的信息内容（包括但不限于网页、文字、图片、音频、视频、图表</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">、制图素材</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">等）的知识产权均归</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >所有，依法属于他人所有的除外。除另有特别声明外，</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >提供本服务时所依托软件的著作权、专利权及其他知识产权均归</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">所有。</span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt"
                >10.2您及用户仅拥有依照本协议约定合法使用本服务的权利，与本服务相关的著作权、专利权等相关全部权利归</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">所有。未经</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">书面许可，您及用户不得违约或违法使用。</span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">1</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">0.3</span
              ><span style="font-family: 微软雅黑; font-size: 12pt; font-weight: bold">您自行创作并上传</span
              ><span style="font-family: 微软雅黑; font-size: 12pt; font-weight: bold">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt; font-weight: bold">，或您利用</span
              ><span style="font-family: 微软雅黑; font-size: 12pt; font-weight: bold">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt; font-weight: bold"
                >提供的技术支持创作的作品及素材的知识产权归您所有。但</span
              ><span style="font-family: 微软雅黑; font-size: 12pt; font-weight: bold">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt; font-weight: bold"
                >有权依据本协议的约定在网站上进行展示、推广、文化经营等工作。</span
              >
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">11.其他</span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">11.1本协议内容同时包括《</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                ><a style="color: blue" @click="active = '4'">创作规范</a></span
              ><span style="font-family: 微软雅黑; font-size: 12pt">》、本协议附件中的协议或规则、</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >可能不断发布的关于本服务的其他相关协议、规则等内容。上述内容一经正式发布，即为本协议不可分割的组成部分，您及用户同样应当遵守。上述内容与本协议存在冲突的，以本协议为准。一经注册或使用本协议下任何服务，即视为您及用户已阅读并同意接受本协议及上述内容的约束。</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >有权在必要时单方修改本协议或上述内容，相关内容变更后，如果您及用户继续使用本服务，即视为您及用户已接受修改后的相关内容。如果您及用户不接受修改后的相关内容，应当停</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">止使用相关服务。</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"> </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">11.2本协议签订地为中华人民共和国</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">广州市海珠区</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">。 </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt"
                >11.3本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。
              </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">11.4若您及用户和</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >之间发生任何纠纷或争议，首先应友好协商解决；协商不成功的，各方均同意将纠纷或争议提交本协议签订地有管辖权的人民法院解决
              </span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt"
                >11.5本协议所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本协议涵义解释的依据。（正文完）</span
              >
            </p>
          </div>
        </div>
        <div v-show="active === '2'">
          <div>
            <h3 style="background-color: #ffffff; line-height: 12pt; margin: 5pt 0pt; text-align: center">
              <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; font-weight: bold"
                >M Art隐私政策</span
              >
            </h3>
            <p style="background-color: #ffffff; line-height: 25pt; margin: 5pt 0pt; text-indent: 21pt">
              <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
                >感谢您选择使用M Art平台，您可以通过多种不同的方式使用我们的服务。我们希望通过本隐私政策让您清楚的了解我们对信息的收集、使用方式，以及您可采用什么方式来保护自己的隐私权。当您注册M Art平台时，视为同意本政策。</span
              >
            </p>
            <p style="background-color: #ffffff; line-height: 25pt; margin: 5pt 0pt">
              <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
                >我们的隐私权政策解释了以下几个方面的问题：</span
              >
            </p>
            <p style="background-color: #ffffff; line-height: 25pt; margin: 5pt 0pt">
              <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
                >（1）我们收集这些信息的目的、范围以及如何收集；</span
              ><br /><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
                >（2）我们对这些信息的使用方式、范围；</span
              ><br /><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
                >（3）信息的安全性；</span
              ><br /><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
                >（4）未成年人信息保护等。</span
              >
            </p>
            <h4 style="background-color: #ffffff; line-height: 25pt; margin: 5pt 0pt">
              <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; font-weight: bold"
                >一、 收集信息的目的</span
              >
            </h4>
            <p style="background-color: #ffffff; line-height: 25pt; margin: 5pt 0pt">
              <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
                >我们通过网站、软件和其他应用程序向您提供更为优质的作品分享、拍照、上传图片、形象贴图等服务。</span
              ><br /><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
                >如果您不同意M Art平台的用户协议和本隐私权政策，请您不要使用M Art平台（如果您已经开始使用M Art平台，请您立即终止使用，您的使用行为即视为您同意。）</span
              ><br /><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
                >如在使用部分功能过程中不同意M Art平台收集、显示和使用您的信息的，将可能会影响到您对此部分功能的使用和体验，您对此表示理解。</span
              >
            </p>
            <h4 style="background-color: #ffffff; line-height: 25pt; margin: 5pt 0pt">
              <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; font-weight: bold"
                >二、 收集信息的类型</span
              >
            </h4>
            <p style="background-color: #ffffff; line-height: 25pt; margin: 5pt 0pt">
              <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
                >按是否能辨识个人身份,本合同项下的信息可以分为以下两类：</span
              ><br /><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
                >（1）可辨识个人身份的信息：包括用户真实姓名、出生日期、身份证件号码、职业、住址、电话号码、账号和密码以及用户使用服务的时间、地点、发布内容能够单独或者与其他信息结合识别用户的信息。</span
              ><br /><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
                >（2）不可辨识个人身份的信息：可以是您使用M Art平台的使用记录、个人喜好这些与您有关但无法直接辨认、追查、鉴别、确认个人真实身份的信息。我们例行收集此类信息并用于改善您的体验。</span
              >
            </p>
            <h4 style="background-color: #ffffff; line-height: 25pt; margin: 5pt 0pt">
              <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; font-weight: bold"
                >三、 我们收集哪些信息/如何收集信息</span
              >
            </h4>
            <p style="background-color: #ffffff; line-height: 25pt; margin: 5pt 0pt">
              <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
                >您在使用M Art平台的同时，不可撤销地同意并授权我们获取您的如下信息：</span
              >
            </p>
            <p style="background-color: #ffffff; line-height: 25pt; margin: 5pt 0pt">
              <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; font-weight: bold"
                >1. 您提交的信息</span
              ><br /><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
                >1) 为向您提供帐号注册服务时进行的用户身份识别，需要您填写手机号码以验证真实性。</span
              ><br /><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
                >2)
                在您需要注销账号时，为验证为本人操作而要求您提供身份证、手机号码、账号持有证明的相关信息、电子邮箱、联系地址，若您是未成年人的，还需提供监护人身份证明及监护人同意提供上述信息的证明材料。</span
              ><br /><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
                >3) 若您提供的信息不完整，则无法使用本服务或在使用过程中受到限制。如信息变更，您应及时更新。</span
              ><br /><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; font-weight: bold"
                >2.您使用M Art平台服务过程中产生的信息</span
              ><br /><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
                >除上述可能会采集的信息外，还可能采集您在使用本服务的过程中所产生的日志信息、IP地址和移动设备所用的版本和设备识别码、相关通讯信息、地理位置信息、Web
                Beacon或Cookie信息及其他使用本服务过程中产生的信息。您可通过终端设备的权限设置关闭相关授权以阻止本软件获取您的相关信息。</span
              ><br /><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; font-weight: bold"
                >3. 我们从第三方获得您个人信息的情形</span
              ><br /><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
                >如您启用第三方应用的服务，我们可能从第三方获取您授权共享的账户信息（头像、昵称），并在您同意本隐私政策后将您的第三方账户与您的软件账户绑定，使您可以通过第三方账户直接登录并使用我们的产品与/或服务。在符合相关本隐私政策的前提下，使用您的这些个人信息。</span
              >
            </p>
            <h4 style="background-color: #ffffff; line-height: 25pt; margin: 5pt 0pt">
              <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; font-weight: bold"
                >四、 信息使用和存储规则</span
              >
            </h4>
            <p style="background-color: #ffffff; margin: 0pt">
              <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
                >1. 我们会根据本隐私政策的约定并为实现我们的产品与/或服务功能对所收集的个人信息进行使用。</span
              ><br /><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">2.</span
              ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">&nbsp;</span
              ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt">您已明确授权</span
              ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
                >，为提供服务、履行协议、解决争议、保障交易安全等目的，M Art平台对您注册所提供的、M Art平台自行收集的及通过第三方收集的您的个人信息、您申请服务时的相关信息、您在使用服务时储存在M Art平台的个人信息享有留存、整理加工、使用和披露的权利，具体方式包括但不限于：</span
              ><br /><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
                >1)
                出于为您帮助完成注册或提供服务的需要获取您的个人信息，对于虚拟账号名称、头像、性别、爱好、生日可在本网站公示。</span
              ><br /><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
                >2)
                使用您的用户信息以改进本网站的设计和推广，对我们的产品与/或服务使用情况进行统计，并可能会与公众或第三方共享这些统计信息，以展示我们的产品与/或服务的整体使用趋势。但当我们展示您的个人信息时，我们会采用包括内容替换、匿名处理方式对您的信息进行脱敏，以保护您的信息安全。</span
              ><br /><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
                >3) 使用您提供的联系方式与您联络并向您传递有关服务和管理方面的信息，对您的个人信息进行分析整合。</span
              ><br /><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
                >4)
                当您与我们联系时，我们可能会保存您的沟通记录和内容或您留下的联系方式等信息，以便与您联系或帮助您解决问题，并记录相关问题的处理方案及结果。</span
              ><br /><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
                >5)
                为方便您在使用服务过程中能使用更换图像、上传或下载图片、实名认证的功能而使用您的相机、相册权限。</span
              ><br /><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
                >6) 出于服务运行过程中的数据存储而使用您的存储权限。</span
              ><br /><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
                >7)在您违反与M Art平台或M Art平台的其他用户签订的协议时，披露您的个人信息及违约事实，将您的违约信息写入黑名单并与必要的第三方共享数据，以供M Art平台及第三方审核、追索之用。</span
              ><br /><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
                >8)
                其他基于特定目的收集而来的信息用于其他目的时，会通过您主动做出勾选或同意的形式事先征求您的同意。</span
              ><br /><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
                >3.
                您同意并授权M Art平台或相关服务提供者向您推送电子广告，推送者会在推送中明示发送者的真实身份和联系方式，并向您提供拒绝继续接收的方式。</span
              ><br /><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
                >4.
                请您注意，您在使用我们的产品与/或服务时所提供的所有个人信息，除非您删除或通过系统设置拒绝我们收集，否则将在您使用我们的产品与/或服务期间持续授权我们使用。在您注销账号时，我们将停止使用并收集您的个人信息。</span
              ><br /><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
                >5
                若非系统崩溃、黑客入侵等意外情况，一般情况下，您的网络操作日志、产品使用记录信息将按照相关法律法规的要求保存至少6个月。账户及软件正常状态下，您可随时浏览、修改自己提交的信息，在访问、更新、更正和删除您的信息时，我们有权要求您进行身份验证，以保障账户安全。</span
              ><br /><span
                style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; text-decoration: underline"
                >6.
                您可通过邮箱M Art@mindcomic.com向我们发送注销账号申请，并按照既定流程提供相应信息以供验证。如您注销账户的，M Art平台有权不再保存您的信息，请您自行做好备份和记录</span
              ><span
                style="
                  background-color: #ffffff;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  font-weight: bold;
                  text-decoration: underline;
                "
                >。</span
              >
            </p>
            <h4 style="background-color: #ffffff; line-height: 25pt; margin: 5pt 0pt">
              <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; font-weight: bold"
                >五、 我们如何保护您的个人信息安全</span
              >
            </h4>
            <p style="background-color: #ffffff; line-height: 25pt; margin: 5pt 0pt">
              <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
                >我们非常重视个人信息安全，并采取一切合理可行的措施，保护您的个人信息。但是请您理解，由于技术的限制以及可能存在的各种恶意手段，即便竭尽所能加强安全措施，也不能完全避免与个人信息安全相关的风险（特别是由于我们可控范围外的因素而引发问题时，如不可抗力或第三方原因等），</span
              ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; font-weight: bold"
                >因此，M Art平台无法确保用户的个人信息完全不被泄露，请您审慎提供个人信息，对于跳转第三方的界面谨慎点击。</span
              ><br /><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
                >如果我们知悉其所获取并储存的数据安全受到危害或由于外部行为收到侵犯，我们仍将采取其认为适当的合理措施（包括但不限于内部调查、上报并通知执法机构以及配合执法机构工作等），我们同时也会在认为适当的情况下采取合法合理措施通知您。</span
              >
            </p>
            <h4 style="background-color: #ffffff; line-height: 25pt; margin: 5pt 0pt">
              <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; font-weight: bold"
                >六、 未成年人的个人信息保护</span
              >
            </h4>
            <p style="background-color: #ffffff; line-height: 25pt; margin: 5pt 0pt">
              <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
                >我们非常重视对未成年人个人信息的保护</span
              ><span
                style="
                  background-color: #ffffff;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  font-weight: bold;
                  text-decoration: underline;
                "
                >并建议未成年人在提交信息之前务必经过父母或监护人的同意和指导。</span
              ><br /><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
                >若您是18周岁以下的未成年人，我们根据国家相关法律法规的规定保护未成年人的个人信息。对于经父母或法定监护人同意而收集未成年人个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用或公开披露此信息。</span
              >
            </p>
            <h4 style="background-color: #ffffff; line-height: 25pt; margin: 5pt 0pt">
              <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; font-weight: bold"
                >七、 其他</span
              >
            </h4>
            <p style="background-color: #ffffff; line-height: 25pt; margin: 5pt 0pt">
              <span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
                >如您还有任何疑问或其他与隐私政策相关的问题、投诉，欢迎通过如下方式与我们取得联系：</span
              ><span
                style="
                  background-color: #ffffff;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  font-weight: bold;
                  text-decoration: underline;
                "
                ><span class="email-word" style="width: 182px; background-color: rgba(0, 0, 0, 0.65);">&nbsp;</span></span
              ><span
                style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; text-decoration: underline"
                >&nbsp;</span
              ><span
                style="
                  background-color: #ffffff;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  font-weight: bold;
                  text-decoration: underline;
                "
              ></span
              ><span
                style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt; text-decoration: underline"
                >&nbsp;</span
              ><span style="background-color: #ffffff; font-family: 微软雅黑; font-size: 12pt"
                >并留下真实有效的联系方式，我们将在收到相关问题或投诉之日起15日内回复。</span
              >
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 微软雅黑; font-size: 12pt">&nbsp;</span>
            </p>
          </div>
        </div>
        <div v-show="active === '3'">
          <div>
            <p
              style="
                font-size: 12pt;
                line-height: 150%;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: center;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt; font-weight: bold">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt; font-weight: bold">版权保护申诉指引</span>
            </p>
            <p style="line-height: 25pt; margin: 0pt 0pt 10pt; orphans: 0; text-indent: 21pt; widows: 0">
              <span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >平台中包含众多用户上传的信息以及其他来自互联网的信息。</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >为保护著作权人的合法权利，根据我国相关法律法规的规定，将通过以下途径保护</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">经营的网站内作品的著作权：</span>
            </p>
            <p
              style="font-size: 12pt; line-height: 150%; margin: 0pt 0pt 10pt; orphans: 0; text-indent: 21pt; widows: 0"
            >
              <span style="font-family: 微软雅黑; font-size: 12pt"
                >“作品”是指受《中华人民共和国著作权法》保护的文学、艺术和科学作品，包括但不限于文字作品、美术作品、表演、录音录像制品等。</span
              >
            </p>
            <p
              style="font-size: 12pt; line-height: 150%; margin: 0pt 0pt 10pt; orphans: 0; text-indent: 21pt; widows: 0"
            >
              <span style="font-family: 微软雅黑; font-size: 12pt"
                >“权利人”是指作品的著作权人或者经著作权人合法授权而享有作品的信息网络传播权的权利享有人。</span
              >
            </p>
            <p
              style="
                font-size: 12pt;
                line-height: 150%;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt; font-weight: bold">通知程序</span>
            </p>
            <p
              style="
                font-size: 12pt;
                line-height: 150%;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">权利人认为</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >的网站中相关信息、搜索或链接的内容所涉及的作品侵犯了其信息网络传播权或者被删除、改变了自己的权利管理电子信息的，可向</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >提交书面通知，要求删除该作品，或者断开该作品的链接。通知书需权利人亲笔签名，若为单位则需加盖单位公章。</span
              >
            </p>
            <p
              style="
                font-size: 12pt;
                line-height: 150%;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">通知书应当包含下列内容：</span>
            </p>
            <p
              style="
                font-size: 12pt;
                line-height: 150%;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（一）</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">
                权利人的姓名（名称）、联系方式、地址、身份证复印件（自然人）、单位登记证明复印件（单位）；</span
              >
            </p>
            <p
              style="
                font-size: 12pt;
                line-height: 150%;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（二）</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">
                要求删除或者断开链接的侵权作品的准确名称和网络地址；</span
              >
            </p>
            <p
              style="
                font-size: 12pt;
                line-height: 150%;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（三）</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">
                认为构成侵权的初步证明材料，包括但不限于对作品享有著作权或依法享有信息网络传播权的权属证明、创作手稿、经权威机构签发的作品创作时间戳、作品备案证书、列举证据证明侵权事实。</span
              >
            </p>
            <p
              style="
                font-size: 12pt;
                line-height: 150%;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（通知书的格式可参考附件）</span>
            </p>
            <p
              style="
                font-size: 12pt;
                line-height: 150%;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt"
                >权利人应对通知书的真实性负责。若通知书的内容不真实，权利人将承担由此造成的全部法律责任。</span
              >
            </p>
            <p
              style="
                font-size: 12pt;
                line-height: 150%;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >收到权利人的通知及完整的证明材料后，将立即删除涉嫌侵权的作品，或者断开涉嫌侵权作品的链接。</span
              >
            </p>
            <p
              style="
                font-size: 12pt;
                line-height: 150%;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt; font-weight: bold">反通知程序</span>
            </p>
            <p
              style="
                font-size: 12pt;
                line-height: 150%;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >将投诉通知到作品提供者，若内容提供者认为作品不侵权的可提供相关证据反通知到</span
              ><span style="font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="font-family: 微软雅黑; font-size: 12pt"
                >。反通知书需作品提供者亲笔签名，若为单位则需加盖单位公章。</span
              >
            </p>
            <p
              style="
                font-size: 12pt;
                line-height: 150%;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt; font-weight: bold">通知书统一收件邮箱：</span
              ><span style="font-family: 微软雅黑; font-size: 12pt; font-weight: bold"><span class="email-word" style="width: 182px; background-color: rgba(0, 0, 0, 0.65);">&nbsp;</span></span>
            </p>
            <p>附件下载</p>
            <p>
              <a href="/download/1.pdf" download="1-要求删除或者断开侵权网络内容的通知.pdf"
                >要求删除或者断开侵权网络内容的通知</a
              >
            </p>
            <p>
              <a href="/download/2.docx" download="2-要求删除或者断开侵权网络内容的通知填写指引.docx"
                >要求删除或者断开侵权网络内容的通知填写指引</a
              >
            </p>
            <p>
              <a href="/download/3.pdf" download="3-要求恢复被删除或断开链接的网络内容的说明.pdf"
                >要求恢复被删除或断开链接的网络内容的说明</a
              >
            </p>
            <p>
              <a href="/download/4.docx" download="4-要求恢复被删除或断开链接的网络内容的说明填写指引.docx"
                >要求恢复被删除或断开链接的网络内容的说明填写指引</a
              >
            </p>
          </div>
        </div>
        <div v-show="active === '4'">
          <div>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                text-align: center;
                text-indent: 21pt;
              "
            >
              <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt; font-weight: bold">M Art</span
              ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt; font-weight: bold">创作规范</span>
            </p>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                >平台致力于为广大用户提供和谐友善的创作环境，为用户提供良</span
              ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                >好的阅读体验，共同打造健康有序的内容生态。平台的可持续发展，有赖于各位用户的共同维护与支持。</span
              >
            </p>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt; font-weight: bold"
                >真诚建议每位用户在制作和发布作品前仔细阅读本规范。如您发布的内容存在以下问题，将无法通过审核或被系统限制推荐范围，违规情节严重的，将对帐号进行警示乃至封号处理，涉嫌违法犯罪的将被移送行政或司法机关。</span
              ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                >请各位用户严格遵守平台的内容创作规范，持续创作更多优质内容。</span
              >
            </p>
            <p
              style="
                background-color: #ffffff;
                border-bottom-color: #eaecef;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                padding-bottom: 4pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #ff0000; font-family: 微软雅黑; font-size: 12pt; font-weight: bold">一、</span
              ><span style="color: #ff0000; font-family: 微软雅黑; font-size: 12pt; font-weight: bold">M Art</span
              ><span style="color: #ff0000; font-family: 微软雅黑; font-size: 12pt; font-weight: bold">平台不允许</span
              ><span style="color: #666666; font-family: 微软雅黑; font-size: 12pt; font-weight: bold"> </span>
            </p>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #666666; font-family: 微软雅黑; font-size: 12pt; font-weight: bold">（1）</span
              ><span style="color: #666666; font-family: 微软雅黑; font-size: 12pt; font-weight: bold"
                >不允许违反法律法规和相关政策
              </span>
            </p>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                >违反法律法规和相关政策的行为及内容，包含但不限于以下场景：</span
              >
            </p>
            <ol type="1" style="margin: 0pt; padding-left: 0pt">
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >违反宪法确定的基本原则，煽动抗拒或者破坏宪法、法律、行政法规实施；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >危害国家统一、主权和领土完整，泄露国家秘密，危害国家安全，损害国家尊严、荣誉和利益，宣扬恐怖主义、极端主义；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >诋毁民族优秀文化传统，煽动民族仇恨、民族歧视，侵害民族风俗习惯、歪曲民族历史和民族历史人物，损害革命领袖、英雄烈士形象，伤害民族感情，破坏民族团结；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >煽动破坏国家宗教政策，宣扬宗教狂热，危害宗教和睦，伤害信教公民宗教感情，破坏信教公民和不信教公民团结，宣扬邪教、封建迷信；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >危害社会公德，扰乱社会秩序，破坏社会稳定，宣扬淫秽色情、赌博、吸毒，渲染暴力、恐怖，教唆犯罪或者传授犯罪方法；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >教唆、教授、组织他人进行违法乱纪活动，以非法民间组织名义活动的，宣传违法违规物品；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >侵害未成年人合法权益或者损害未成年人身心健康；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >侵犯他人隐私，侮辱或者诽谤他人，侵害他人合法权益；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >含有法律、行政法规、规章、条例以及任何具有法律效力之规范所限制或禁止的其它内容。</span
                >
              </li>
            </ol>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #666666; font-family: 微软雅黑; font-size: 12pt; font-weight: bold">（2）</span
              ><span style="color: #666666; font-family: 微软雅黑; font-size: 12pt; font-weight: bold"
                >不允许抄袭侵权
              </span>
            </p>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">包含但不限于以下场景：</span>
            </p>
            <ol type="1" style="margin: 0pt; padding-left: 0pt">
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >未经授权使用他人享有著作权的内容，包括但不限于以洗稿、复制拼凑等方式重新整合，在表达上与在先作品存在实质性的相同或近似的内容；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >违规使用「原创」功能的：指在平台申请声明「原创」，但内容被证实不符合原创标准要求的。</span
                >
              </li>
            </ol>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #666666; font-family: 微软雅黑; font-size: 12pt; font-weight: bold">（3）</span
              ><span style="color: #666666; font-family: 微软雅黑; font-size: 12pt; font-weight: bold"
                >不允许无资质发布专业领域内容
              </span>
            </p>
            <ol type="1" style="margin: 0pt; padding-left: 0pt">
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >未取得互联网新闻信息服务许可，不得发布新闻信息，新闻信息指：时政类新闻信息，包括有关政治、经济、军事、外交等社会公共事务的报道、评论，以及有关社会突发事件的报道、评论；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >未申请健康类专业资质认证的个人和机构，不得发布疾病治疗、用药指导等健康领域专业性强的内容；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >未申请财经类专业资质认证的个人和机构，不得发布股票买卖指导、投资指南等财经领域专业性强的内容；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >我国法律法规要求必须取得特定资质方可从事特定行为的其他情形，依该等法律法规要求处理。</span
                >
              </li>
            </ol>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #666666; font-family: 微软雅黑; font-size: 12pt; font-weight: bold">（4）</span
              ><span style="color: #666666; font-family: 微软雅黑; font-size: 12pt; font-weight: bold"
                >不允许发布谣言或不实内容</span
              >
            </p>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">包含但不限于以下场景：</span>
            </p>
            <ol type="1" style="margin: 0pt; padding-left: 0pt">
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >明显谣言或虚假：与事实相悖或违背科学常理，凭空杜撰、拼凑、编造或曲解事实，制造耸人听闻的谣言，影响较为恶劣；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >疑似谣言：无可信来源，断章取义或以讹传讹，存在诋毁、人身攻击等负面影响的；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">信息有误 </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt; font-weight: bold">：</span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">
                  发布内容与事实不一致、关键信息不准确，或歪曲事实等行为。</span
                >
              </li>
            </ol>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #666666; font-family: 微软雅黑; font-size: 12pt; font-weight: bold">（5）</span
              ><span style="color: #666666; font-family: 微软雅黑; font-size: 12pt; font-weight: bold">不允许未经</span
              ><span style="color: #666666; font-family: 微软雅黑; font-size: 12pt; font-weight: bold">M Art</span
              ><span style="color: #666666; font-family: 微软雅黑; font-size: 12pt; font-weight: bold"
                >同意的商品推广或违规推广
              </span>
            </p>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">违规推广包含但不限于以下场景：</span>
            </p>
            <ol type="1" style="margin: 0pt; padding-left: 0pt">
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >违禁商品推广：法律规定不准私自制造、买卖、使用、持有、储存、运输、进出口的物品及其他平台禁售商品，如枪支弹药、违禁药品、走私商品等；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >有风险商品推广：对人身健康、财产等存在风险的商品，或过分夸大效果、违反基本常识的虚假宣传；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >未知风险商品推广：除上述两种情况外，其他无法明确判断商品用途及功效，但可能存在未知风险的。</span
                >
              </li>
            </ol>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #666666; font-family: 微软雅黑; font-size: 12pt; font-weight: bold">（6）</span
              ><span style="color: #666666; font-family: 微软雅黑; font-size: 12pt; font-weight: bold"
                >不允许流量作弊
              </span>
            </p>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                >滥用产品功能进行流量作弊，批量发布重复、无意义的低质内容，恶意刷粉刷赞，影响用户体验、破坏平台规则且损害他人权益的行为。包含但不限于以下场景：</span
              >
            </p>
            <ol type="1" style="margin: 0pt; padding-left: 0pt">
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">违规批量发文：</span>
              </li>
            </ol>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt 21.25pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">(1)</span
              ><span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
              ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                >批量发布重复内容：一段时间内，用非正常手段连续发布大量重复内容，或高度相似内容；</span
              >
            </p>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt 21.25pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">(2)</span
              ><span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
              ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                >批量发无意义/低质内容：连续或大量发布无意义元素，包括但不限于无意义图片、符号、表情、乱码、无序文字等；</span
              >
            </p>
            <ol start="2" type="1" style="margin: 0pt; padding-left: 0pt">
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >违规刷粉刷赞：通过非正常手段进行作弊，获取虚假粉丝、虚假点赞数据的行为。</span
                >
              </li>
            </ol>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #666666; font-family: 微软雅黑; font-size: 12pt; font-weight: bold">（7）</span
              ><span style="color: #666666; font-family: 微软雅黑; font-size: 12pt; font-weight: bold"
                >不允许发布引人不适或反感的内容</span
              >
            </p>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">包含但不限于以下场景：</span>
            </p>
            <ol type="1" style="margin: 0pt; padding-left: 0pt">
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >血腥暴力：对真实的人或动物实施暴力，煽动他人施暴；内容中有大量血腥画面，未经过马赛克遮挡，引起用户不适，如尸体、内脏器官等；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >密集恐惧：密集排列、分布的事物，造成感官不适；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >猎奇：以猎奇为目的，描述或展现异常事物，引起不适或有不良诱导；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >恶心：引起强烈刺激的事物，如排泄物，吃活物、体验恶心食物等；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >恐怖：内容惊悚的事件，或让人产生恐惧心理的生物，具有令人不寒而栗的特征，如人尸、蛇等；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >虐待动物：如展示摔打或使用其他工具伤害动物的行为，渲染虐待动物的快感。</span
                >
              </li>
            </ol>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #666666; font-family: 微软雅黑; font-size: 12pt; font-weight: bold">（8）</span
              ><span style="color: #666666; font-family: 微软雅黑; font-size: 12pt; font-weight: bold"
                >不允许宣扬不良价值观
              </span>
            </p>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">包含但不限于以下场景：</span>
            </p>
            <ol type="1" style="margin: 0pt; padding-left: 0pt">
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >挑战公序良俗或游走在社会道德边缘的行为；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >展示违背伦理道德的糜烂生活；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >宣扬不良生活方式和不良流行文化，渲染消极情绪，宣扬颓废的人生观、世界观和价值观；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">宣扬拜金主义和享乐主义；</span>
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >宣传和宣扬丧文化、自杀游戏；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >以肯定、赞许的基调或引入模仿的方式表现打架斗殴、羞辱他人、污言秽语；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">恶意对比、引战行为。</span>
              </li>
            </ol>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #666666; font-family: 微软雅黑; font-size: 12pt; font-weight: bold">（9）</span
              ><span style="color: #666666; font-family: 微软雅黑; font-size: 12pt; font-weight: bold"
                >不允许诱导低俗
              </span>
            </p>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                >渲染低俗及宣扬低级趣味的行为和内容。包含但不限于以下场景：</span
              >
            </p>
            <ol type="1" style="margin: 0pt; padding-left: 0pt">
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >对性部位和性行为进行展示、过度描述或内涵表述的；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >有明显的性挑逗、性骚扰、性侮辱或类似效果的画面、台词、音乐及音效等；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >以成人电影、情色电影、三级片、偷拍、走光、露点及各种挑逗性文字或图片作为内容标题、分类或宣传推广；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >发布和传播其他有伤社会风化的内容。</span
                >
              </li>
            </ol>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #666666; font-family: 微软雅黑; font-size: 12pt; font-weight: bold">（10）</span
              ><span style="color: #666666; font-family: 微软雅黑; font-size: 12pt; font-weight: bold"
                >不允许不文明用语
              </span>
            </p>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">包含但不限于以下场景：</span>
            </p>
            <ol type="1" style="margin: 0pt; padding-left: 0pt">
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >骚扰辱骂：使用污言秽语、蔑称、外号、同音近音词等直接辱骂或言语骚扰他人；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >歧视恶搞：恶搞、歧视特定群体，或言论带有明显的性别歧视、种族歧视、地域歧视等；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >情绪宣泄：通过粗俗不堪的口头禅、网络用语等发泄情绪，表达不满的。</span
                >
              </li>
            </ol>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #666666; font-family: 微软雅黑; font-size: 12pt; font-weight: bold">（11）</span
              ><span style="color: #666666; font-family: 微软雅黑; font-size: 12pt; font-weight: bold"
                >不允许恶意营销
              </span>
            </p>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                >以恶意营销或诱导消费为目的，内容附带联系方式、售卖链接，或诱导私信联系转线下交易，引导用户消费但可能存在风险的行为。包含但不限于以下场景：</span
              >
            </p>
            <ol type="1" style="margin: 0pt; padding-left: 0pt">
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >联系方式：如电话号码、微信号、公众号、二维码、微信群等；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >营销链接：带有明显营销意图的第三方网址，或诱导用户在第三方电商平台领取红包、购买交易的口令和店铺号等；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">引导交易；</span>
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >票务售卖：明确公示价格，买卖转让演唱会门票等；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >虚拟交易：推广虚拟货币、虚拟商品、虚拟服务类交易，如游戏点卡、游戏在线服务、网游装备、QQ号码、Q币、软件序列号、电子书等；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >求资源/诱导私信联系：诱导读者通过私信渠道联系或获取资源（如联系方式、链接、加微信群等）；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >纯广告：以推广产品、盈利为目的作品，包括产品宣传、商业服务宣传、商业赞助宣传、商业展销宣传、商家优惠酬宾宣传等。</span
                >
              </li>
            </ol>
            <p
              style="
                background-color: #ffffff;
                border-bottom-color: #eaecef;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                padding-bottom: 4pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #ff0000; font-family: 微软雅黑; font-size: 12pt; font-weight: bold">二、</span
              ><span style="color: #ff0000; font-family: 微软雅黑; font-size: 12pt; font-weight: bold">M Art</span
              ><span style="color: #ff0000; font-family: 微软雅黑; font-size: 12pt; font-weight: bold">平台不鼓励</span>
            </p>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #666666; font-family: 微软雅黑; font-size: 12pt; font-weight: bold">（1）</span
              ><span style="color: #666666; font-family: 微软雅黑; font-size: 12pt; font-weight: bold"
                >不鼓励标题低质
              </span>
            </p>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                >通过夸张描述、隐瞒信息、扭曲原意等方式增加标题吸引力，引诱用户阅读，但与内文真实情况不符，造成用户阅读后心理落差与不良体验。包含但不限于以下场景：</span
              >
            </p>
            <ol type="1" style="margin: 0pt; padding-left: 0pt">
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">标题夸张：</span>
              </li>
            </ol>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt 21.25pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">(1)</span
              ><span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
              ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                >夸张式标题：将感受、范围、结果、程度等夸张夸大描述，造成耸人听闻的效果；</span
              >
            </p>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt 21.25pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">(2)</span
              ><span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
              ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                >悬念式标题：标题滥用转折、隐藏关键性信息，营造悬念、故弄玄虚；</span
              >
            </p>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt 21.25pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">(3)</span
              ><span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
              ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                >强迫式标题：标题采用挑衅恐吓、强迫建议等方式，诱导用户阅读；</span
              >
            </p>
            <ol start="2" type="1" style="margin: 0pt; padding-left: 0pt">
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">标题与内容原意有偏差：</span>
              </li>
            </ol>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt 21.25pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">(1)</span
              ><span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
              ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                >标题存在歧义 ：标题对要素信息的表达不清晰、不对称或不完整，形成冲突，对用户产生误导；</span
              >
            </p>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt 21.25pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">(2)</span
              ><span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
              ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                >标题无中生有 ：标题捏造内容中不存在的人、物、情节、言论等，或用猜测、不确定消息诱导用户点击；</span
              >
            </p>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt 21.25pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">(3)</span
              ><span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
              ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                >标题滥用名称、题材不明确：标题未明确所涉及题材，滥用演员名代替剧中人物名，或用新闻式标题描述影视剧情节，引起歧义，误导用户认为是明星花边或社会时政负面；</span
              >
            </p>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt 21.25pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">(4)</span
              ><span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
              ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                >封面与标题不符： 封面图与内容主体完全不相关，或封面图结合标题易使读者产生误解；</span
              >
            </p>
            <ol start="3" type="1" style="margin: 0pt; padding-left: 0pt">
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >标题不规范：标题含有错别字或存在语病、滥用标点符号、语义不通顺等，影响理解与阅读体验。</span
                >
              </li>
            </ol>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #666666; font-family: 微软雅黑; font-size: 12pt; font-weight: bold">（2）</span
              ><span style="color: #666666; font-family: 微软雅黑; font-size: 12pt; font-weight: bold"
                >不鼓励话题无关</span
              >
            </p>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                >发布内容与所带话题的内容不相关，如内容未提及话题主体、内容与话题城市异地、只带话题不写内容等。</span
              >
            </p>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #666666; font-family: 微软雅黑; font-size: 12pt; font-weight: bold">（3）</span
              ><span style="color: #666666; font-family: 微软雅黑; font-size: 12pt; font-weight: bold"
                >不鼓励封面/配图低质</span
              >
            </p>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                >封面或配图内容质量差，与文章主体无关且不能为文章增补信息量。包含但不限于以下场景：</span
              >
            </p>
            <ol type="1" style="margin: 0pt; padding-left: 0pt">
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >图片与内容毫无关联，且图片质量差的；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >图文明显不相关，带不良图片蹭流量的，图片类型包含但不限于如下：</span
                >
              </li>
            </ol>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt 21.25pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">(1)</span
              ><span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
              ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">有不良诱导倾向的图片；</span>
            </p>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt 21.25pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">(2)</span
              ><span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
              ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">偷拍类图片；</span>
            </p>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt 21.25pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">(3)</span
              ><span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
              ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                >男女亲密同框，易引发低俗、恶俗等不良想象图片等。</span
              >
            </p>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #666666; font-family: 微软雅黑; font-size: 12pt; font-weight: bold">（4）</span
              ><span style="color: #666666; font-family: 微软雅黑; font-size: 12pt; font-weight: bold"
                >不鼓励内容低质
              </span>
            </p>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                >图文格式混乱或不美观，音画质量差等影响阅读体验。包含但不限于以下场景：</span
              >
            </p>
            <ol type="1" style="margin: 0pt; padding-left: 0pt">
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >图文低质的内容，包含但不限于以下场景：</span
                >
              </li>
            </ol>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt 21.25pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">(1)</span
              ><span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
              ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                >排版混乱：文章乱码、无段落或无标点；</span
              >
            </p>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt 21.25pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">(2)</span
              ><span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
              ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                >语意不明：病句或错别字较多、乱码符号，有碍于读者理解内容；</span
              >
            </p>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt 21.25pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">(3)</span
              ><span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
              ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                >逻辑混乱：内容拼凑或重复，前后内容没有衔接，无关内容占比较大；</span
              >
            </p>
            <ol start="2" type="1" style="margin: 0pt; padding-left: 0pt">
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >音画低质的内容，包括但不限于以下场景：</span
                >
              </li>
            </ol>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt 21.25pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">(1)</span
              ><span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
              ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                >视频缩放画面：视频中角标/logo/字幕被剪切，导致显示不全，或画面中人物面部被部分剪切；</span
              >
            </p>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt 21.25pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">(2)</span
              ><span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
              ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                >视频添加边框：视频添加边框且占比较大，或水印遮挡画面严重，无法识别视频主体；</span
              >
            </p>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt 21.25pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">(3)</span
              ><span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
              ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                >视频添加滤镜：画面带有严重滤镜至色彩失真，或人物明显发白、发红，呈现不正常色调；</span
              >
            </p>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt 21.25pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">(4)</span
              ><span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
              ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                >视频画面倾斜：画面整体被侧置或倒置，字幕、logo、左右等特征为镜像翻转，或画面被非正常拉长或挤压变形。</span
              >
            </p>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #666666; font-family: 微软雅黑; font-size: 12pt; font-weight: bold">（5）</span
              ><span style="color: #666666; font-family: 微软雅黑; font-size: 12pt; font-weight: bold"
                >不鼓励发布已过时效内容
              </span>
            </p>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                >指发布的资讯、消息等是已经过期的内容，并非新近发生的，因时间不明确、隐藏时间词或时间词过期等引起读者理解偏差、混淆了事件的真实发生时间。包含但不限于以下场景：</span
              >
            </p>
            <ol type="1" style="margin: 0pt; padding-left: 0pt">
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">旧闻新发：</span>
              </li>
            </ol>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt 21.25pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">(1)</span
              ><span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
              ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                >明确时间陈旧：时间明确且已过时，事件已结束，近期无后续、无持续影响和相关讨论的；</span
              >
            </p>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt 21.25pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">(2)</span
              ><span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
              ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                >时间不明：文章中提到的事件为很久之前发生的，特意隐去时间，易误导他人是新近发生的事件；</span
              >
            </p>
            <ol start="2" type="1" style="margin: 0pt; padding-left: 0pt">
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >信息陈旧：指事件持续发酵，已经有新进展、数据有更新、有新的结论，但仍发布陈旧的信息；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >时间词过时：有明确的时间限定词，如「今天」「本月」等，而内容发布时间与限定范围不符，容易引起阅读误解的。</span
                >
              </li>
            </ol>
            <p
              style="
                background-color: #ffffff;
                border-bottom-color: #eaecef;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                line-height: 25pt;
                margin: 0pt 0pt 10pt 21pt;
                padding-bottom: 4pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #ff0000; font-family: 微软雅黑; font-size: 12pt; font-weight: bold"
                >三、涉及以下严重违规行为，一经发现，即刻封禁帐号</span
              ><span style="color: #666666; font-family: 微软雅黑; font-size: 12pt; font-weight: bold"> </span>
            </p>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">（1）</span
              ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                >违反法律法规和相关政策的行为及内容，包含但不限于以下场景：</span
              >
            </p>
            <ol type="1" style="margin: 0pt; padding-left: 0pt">
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">违反宪法确定的基本原则的；</span>
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >危害国家安全，泄露国家秘密，颠覆国家政权、破坏祖国统一、民族团结的；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >破坏国家宗教政策，宣扬邪教、封建迷信的；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >危害社会公德，扰乱社会秩序，破坏社会稳定，宣扬淫秽色情、赌博、吸毒，渲染暴力、恐怖，教唆犯罪或者传授犯罪方法的；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >私自制造、买卖、使用、持有、储存、运输、进出口违规物品，如枪支弹药、管制刀具、毒品、违禁药品、走私商品等；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">发布赌博、传销等违规内容；</span>
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >损害革命领袖、英雄烈士形象；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >发布法律、法规禁止的其他内容。</span
                >
              </li>
            </ol>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">（2）</span
              ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">发布或诱导色情低俗的内容：</span>
            </p>
            <ol type="1" style="margin: 0pt; padding-left: 0pt">
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >对性部位和性行为进行展示、过度描述或内涵表述的；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >有明显的性挑逗、性骚扰、性侮辱或类似效果的画面、台词、音乐及音效等；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >传播色情网站、色情交易或联系方式的。</span
                >
              </li>
            </ol>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">（3）</span
              ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                >发布或传播虚假信息并造成恶劣影响的：</span
              >
            </p>
            <ol type="1" style="margin: 0pt; padding-left: 0pt">
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >杜撰、编造或曲解事实，制造与事实相悖或违背科学常理的谣言；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >伪造或恶意传播虚假系统信息，包括但不限于系统通知、系统数据；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >杜撰、编造社会负面/敏感事件进行商品分享。</span
                >
              </li>
            </ol>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">（4）</span
              ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                >仿冒机构、个人，包括但不限于名人明星、党政机关、新闻机构、公职人员、</span
              ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">官方人员、</span
              ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">M Art</span
              ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                >官方活动等，诱骗他人或造成恶劣影响的。</span
              >
            </p>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">（5）</span
              ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                >恶意攻击谩骂，使用污言秽语、侮辱性语言或称呼等直接辱骂、骚扰平台或用户。</span
              >
            </p>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">（6）</span
              ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                >发布暴力、血腥或其他引人不适的内容：</span
              >
            </p>
            <ol type="1" style="margin: 0pt; padding-left: 0pt">
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >自残自杀写实画面、过程实拍，展示暴力实施场景；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >内容中渲染虐待动物的快感，展示伤害动物的行为。</span
                >
              </li>
            </ol>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">（7）</span
              ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                >发布或传播损害未成年人身心的行为及内容，包含但不限于以下场景：</span
              >
            </p>
            <ol type="1" style="margin: 0pt; padding-left: 0pt">
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >标题或内容含有猥亵未成年，接触未成年性器官，未成年人模拟性行为；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >出现未成年裸露、三点部位衣着不整齐、性器官特写或强调未成年性部位衣着；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">殴打、虐待未成年；</span>
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >鼓动未成年人使用或贩卖非法药品、毒品。</span
                >
              </li>
            </ol>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">（8）</span
              ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                >无资质发布专业领域内容并造成恶劣影响的：</span
              >
            </p>
            <ol type="1" style="margin: 0pt; padding-left: 0pt">
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >无健康领域专业资质发布疾病诊疗、用药指导、针灸拔罐等内容；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >无财经相关专业资质发布股票买卖指导、投资指南等内容。</span
                >
              </li>
            </ol>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">（9）</span
              ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                >发布恶意营销内容，包括但不限于以下形式：</span
              >
            </p>
            <ol type="1" style="margin: 0pt; padding-left: 0pt">
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >推广微信或微信公众号时使用变体，如薇欣、伽这个 薇、微^信`公`众`号等；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >联合推广，即多个帐号重复多次推荐同一产品或同一联系方式；</span
                >
              </li>
            </ol>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt 21.25pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">(1)</span
              ><span style="font: 7pt 'Times New Roman'"
                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
              ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                >产品：包括但不限于网赚兼职、养生健康、优惠券、交友软件、两性用品、收藏品等；</span
              >
            </p>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt 21.25pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">(2)</span
              ><span style="font: 7pt 'Times New Roman'"
                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
              ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                >联系方式：包括但不限于qq号、qq群、微信号、微信公众号等；</span
              >
            </p>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt 21.25pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">(3)</span
              ><span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
              ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">发布风险医疗内容：</span>
            </p>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt 21.25pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">(4)</span
              ><span style="font: 7pt 'Times New Roman'"
                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
              ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                >推广非正规医疗场所或医疗服务，包括未知安全性的药品、保健品、医美项目、医疗活动等；</span
              >
            </p>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt 21.25pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">(5)</span
              ><span style="font: 7pt 'Times New Roman'"
                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
              ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                >宣传违法违规的医疗行为，如非法代孕，胎儿性别鉴定，非法器官移植等；</span
              >
            </p>
            <ol start="3" type="1" style="margin: 0pt; padding-left: 0pt">
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">发布风险投资内容：</span>
              </li>
            </ol>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt 21.25pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">(1)</span
              ><span style="font: 7pt 'Times New Roman'"
                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
              ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                >荐股荐彩：推荐购买指定股票、博彩（包含彩票、足彩、六合彩、赌球、跑马）等高风险投资产品，含有联系方式或引导关注第三方帐号的；</span
              >
            </p>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt 21.25pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">(2)</span
              ><span style="font: 7pt 'Times New Roman'"
                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
              ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                >诱导投资：含诱导他人参与投资的各类推广话术，包括但不限于P2P、区块链、各种网赚等；</span
              >
            </p>
            <ol start="4" type="1" style="margin: 0pt; padding-left: 0pt">
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >发表贵重收藏品内容中含有联系方式或诱导关注第三方帐号；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >宣传直销、网赚兼职并鼓吹小成本获大收益，脱离现实（例：住家创业，手机操作即可月入xx万）；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >售卖高仿表、假烟、假冒名牌服饰等；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >宣传推广封建迷信内容时，如风水转运、画符解咒等，含联系方式或引导关注的；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >发布PUA内容，或情感挽回、婚姻挽回等含有联系方式的；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >发布的视频、音频内容含有语音推广信息；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >宣传刷粉刷量工具、外挂工具、违规查他人隐私信息等违规工具或产品；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >通过美女图片/视频、低俗小说/段子，引导关注第三方帐号的；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >恶意发布社会负面/敏感事件进行商品分享并造成恶劣影响的；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >恶意借国家领导人、公检法军、国家机关、国徽国旗等形象为企业或产品宣传推广。</span
                >
              </li>
            </ol>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">（10）</span
              ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">发布大量低质内容：</span>
            </p>
            <ol type="1" style="margin: 0pt; padding-left: 0pt">
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >发布大量内容低质文章，标题、内文夸张耸动；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >发布大量语句不通、机器编译的内容。</span
                >
              </li>
            </ol>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">（11）</span
              ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                >恶意躲避或对抗平台规则，包括但不限于以下行为：</span
              >
            </p>
            <ol type="1" style="margin: 0pt; padding-left: 0pt">
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >恶意批量注册账号，养号囤号，买卖帐号；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >买卖或使用虚假的身份资料、专业资格证明、版权证明、机构资质等证明材料进行帐号注册、认证或开通平台其他功能；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >存在刷粉、刷量、刷赞或其他作弊行为；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >通过非正常手段发布大量内容；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >发布视频时恶意缩放画面、变速、添加滤镜、变声并影响恶劣的；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >使用转发抽奖功能时，出现违规不兑现奖品或通过抽奖索要钱财等行为。</span
                >
              </li>
            </ol>
            <p
              style="
                background-color: #ffffff;
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                text-align: justify;
                text-indent: 21pt;
              "
            >
              <span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">（12）</span
              ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">滥用平台功能进行违规推广：</span>
            </p>
            <ol type="1" style="margin: 0pt; padding-left: 0pt">
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >在「自定义菜单」或「扩展链接」中添加违规推广内容；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >使用平台链接类功能进行推广（包括但不限于「自定义菜单」「文章插入外链」「扩展链接」）时，插入直接下载的APK链接；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt">恶意篡改自营广告落地页；</span>
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >帐号被关闭商品权限后，直接在文中推广商品链接或引导跳转到此前已发布的其他商品文章；</span
                >
              </li>
              <li
                style="
                  background-color: #ffffff;
                  color: #333333;
                  font-family: 微软雅黑;
                  font-size: 12pt;
                  line-height: 25pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 10pt 21.25pt;
                  text-align: justify;
                  text-indent: 21pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span
                ><span style="color: #333333; font-family: 微软雅黑; font-size: 12pt"
                  >文中引导二次跳转到其他违规推广页面。</span
                >
              </li>
            </ol>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt; font-weight: bold; text-decoration: underline"
                >本规范为《用户协议》的组成部分，用户同意《用户协议》，则视为已阅读、理解并同意本规范。</span
              >
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 微软雅黑; font-size: 12pt">（以下无正文）</span>
            </p>
            <p
              style="
                line-height: 25pt;
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                text-indent: 21pt;
                widows: 0;
              "
            >
              <span style="font-family: 仿宋; font-size: 12pt">&nbsp;</span>
            </p>
          </div>
        </div>
        <div v-show="active === '5'">
          <div>
            <p style="margin: 0pt; orphans: 0; text-align: center; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold">美术作品合作协议</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: center; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">本协议系由广州漫图软件科技有限公司（以下简称</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">"</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">漫图</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">"</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">）与所有通过</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >平台发布作品的用户就资源的引入、使用及相关服务所订立的有效合约，您必须同意并遵守本协议。</span
              >
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt"
                >请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款以及本协议末页的《版权承诺书》，以及其他开通或使用某项服务的单独协议、规则。</span
              >
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">您</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">使用</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">的服务或</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >通过任何方式参与美术作品提交均被视为您完全接受本协议。本协议具有合同效力。</span
              >
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">一、总则</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">1.1</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">本协议内容包括协议正文及所有</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">漫图</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">及</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >平台已经发布的或将来可能发布的各类规则。所有规则为本协议不可分割的组成部分，与协议正文具有同等法律效力。</span
              >
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">1.2 </span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >双方承诺接受并遵守本协议的约定。本协议一经签署立即生效。</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">漫图</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">有权根据</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >平台发展需要对本协议条款进行修订，修订后的协议将公布于</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >平台上，一旦公布即有效替代原有协议。您可随时查询最新协议。如您继续使用</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台服务，即视为您对修订后</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">的协议不持任何异议并完全同意</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">并遵守。如您不同意本服务协议及</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">/</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">或对其的修改，可以</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">通过注销账户的方式</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">主动取消</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台提供的服务，您可向</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台书面提出退出申请，但您在</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台确认您退出许可前的行为，仍受本协议约束。</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">二、定义</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">2.1 “</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">”</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">：是指由</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">漫图</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">所有并运营的供</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">画师</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">在线分享</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">美术作品及美术素材</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">的开放平台。网</span
              ><span style="background-color: #ffff00; font-family: 华文仿宋; font-size: 12pt">址为：</span
              ><span
                style="background-color: #ffff00; font-family: 华文仿宋; font-size: 12pt; text-decoration: underline"
                >http://www.</span
              ><span
                style="background-color: #ffff00; font-family: 华文仿宋; font-size: 12pt; text-decoration: underline"
                >zpace</span
              ><span
                style="background-color: #ffff00; font-family: 华文仿宋; font-size: 12pt; text-decoration: underline"
                >.</span
              ><span
                style="background-color: #ffff00; font-family: 华文仿宋; font-size: 12pt; text-decoration: underline"
                >com.cn/index.html</span
              ><span style="background-color: #ffff00; font-family: 华文仿宋; font-size: 12pt">。</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">2.2 “</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">美术</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">作品</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">”</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">：指您通过</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">上传</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">并经</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">审核</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">通过的</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">美术作品及美术素材。</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">2.4 “</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">用户</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">”</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">：是指在</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">上传美术</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">作品的互联网用户。</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">2.5 “</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">注册</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">”</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">：是指您登陆</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >平台，按要求填写相关信息并提供相关资质材料，在线申请并激活您的服务账户的过程。注册的您必须是拥有合法的</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">美术</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">作品相关版权的</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">自然人</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >，如您违反本协议有关您的规定或超越您民事权利能力或民事行为能力范围的，则本协议自始无效，一经发现，</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台有权立即</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">停止向您提供服务</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">，删除涉事</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">美术</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">作品，并追究您违约使用</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台服务的法律责任。</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">2.6 “</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">您的账户</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">”</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">：即您完成注册流程而获得的在使</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">用</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台服务的过程</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">中必须与您自设的账户密码共同使用的用户名</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">和密码（口令）</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">。您应妥善保管您的服务账户及密码</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">（口令）</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >信息，不得以任何形式擅自转让或授权他人使用您自己的账户。</span
              >
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">2.7 “</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">漫图</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">及</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">漫图</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">关联公司</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">”</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">：</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">漫图</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">是指</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">广州漫图软件科技有限公司</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">，</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">漫图</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">关联公司是指</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">漫图</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">各级母公司以及其他由</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">漫图</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">、其母公司直接或间接拥有或控制的公司。</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">2.8 “</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">画师认证</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">”</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">：</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >您按平台要求提供或填写相关资料，证明您具有美术作品的创作能力、或者证明您是美术作品的创作者的过程。</span
              >
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">三、平台模式</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt; font-weight: normal">3.1 </span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: normal">漫图</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: normal">向您提供</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: normal">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: normal"
                >平台及相关服务，使您得以通过</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: normal">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: normal">平台发布</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: normal">美术</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: normal">作品</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: normal">。</span
              ><span
                style="
                  background-color: #e5e5e5;
                  font-family: 华文仿宋;
                  font-size: 12pt;
                  font-weight: bold;
                  text-decoration: underline;
                "
                >经</span
              ><a name="_Hlk42074279"
                ><span
                  style="
                    background-color: #e5e5e5;
                    font-family: 华文仿宋;
                    font-size: 12pt;
                    font-weight: bold;
                    text-decoration: underline;
                  "
                  >M Art</span
                ><span
                  style="
                    background-color: #e5e5e5;
                    font-family: 华文仿宋;
                    font-size: 12pt;
                    font-weight: bold;
                    text-decoration: underline;
                  "
                  >平台</span
                ></a
              ><span
                style="
                  background-color: #e5e5e5;
                  font-family: 华文仿宋;
                  font-size: 12pt;
                  font-weight: bold;
                  text-decoration: underline;
                "
                >审核通过的美术作品，</span
              ><span
                style="
                  background-color: #e5e5e5;
                  font-family: 华文仿宋;
                  font-size: 12pt;
                  font-weight: bold;
                  text-decoration: underline;
                "
                >M Art</span
              ><span
                style="
                  background-color: #e5e5e5;
                  font-family: 华文仿宋;
                  font-size: 12pt;
                  font-weight: bold;
                  text-decoration: underline;
                "
                >平台</span
              ><span
                style="
                  background-color: #e5e5e5;
                  font-family: 华文仿宋;
                  font-size: 12pt;
                  font-weight: bold;
                  text-decoration: underline;
                "
                >可以自行将该等美术作品在第三方网络平台或移动互联网平台上</span
              ><span
                style="
                  background-color: #e5e5e5;
                  font-family: 华文仿宋;
                  font-size: 12pt;
                  font-weight: bold;
                  text-decoration: underline;
                "
                >定价</span
              ><span
                style="
                  background-color: #e5e5e5;
                  font-family: 华文仿宋;
                  font-size: 12pt;
                  font-weight: bold;
                  text-decoration: underline;
                "
                >并</span
              ><span
                style="
                  background-color: #e5e5e5;
                  font-family: 华文仿宋;
                  font-size: 12pt;
                  font-weight: bold;
                  text-decoration: underline;
                "
                >接受用户付费后对美术作品的浏览、下载或其他使用需求。</span
              >
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span
                style="
                  background-color: #e5e5e5;
                  font-family: 华文仿宋;
                  font-size: 12pt;
                  font-weight: bold;
                  text-decoration: underline;
                "
                >M Art</span
              ><span
                style="
                  background-color: #e5e5e5;
                  font-family: 华文仿宋;
                  font-size: 12pt;
                  font-weight: bold;
                  text-decoration: underline;
                "
                >平台</span
              ><span
                style="
                  background-color: #e5e5e5;
                  font-family: 华文仿宋;
                  font-size: 12pt;
                  font-weight: bold;
                  text-decoration: underline;
                "
                >与第三方平台结算后，按照本协议的约定向您支付分成收益。</span
              >
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">3.2 </span
              ><span style="font-family: 华文仿宋; font-size: 12pt">漫图和</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >均不获取您的美术作品的著作权，但为实现本协议之目的：</span
              >
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">自本协议生效后，您</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">对在</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">上传的美术</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">作品</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">授权漫图以下权利：</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">包括但不限于将您的</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">美术作品</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">在</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">、</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold"
                >第三方网络平台或第三方移动互联网平台</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >进行上传、复制、传输、通过信息网络传播、推广，供</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">站内或第三方平台的</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">用户在付费后以浏览、阅读</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">、改编、汇编</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">或者下载等方式使用；并授权</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >平台将您的美术作品基于互联网或无线互联网形式面向全球用户进行推广。</span
              >
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">3</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">.3 </span
              ><span style="font-family: 华文仿宋; font-size: 12pt">您同意，</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">站内或第三方平台的</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">用户在付费后</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">，可以通过复制、上传、通</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >过信息网络传播、改编、汇编、二次创作等方式您的美术作品。</span
              >
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">3</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">.4</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >如果漫图与您另行签署著作权转让协议的，作品权利归属以协议约定的为准。</span
              >
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">四、合作内容</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">4.1 </span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台和您展开以下合作</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">1)</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">免费技术支持：</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">您免费上传美术作品，</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">向您免费提供</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >技术支持和服务，您自愿、自行上传您的美术作品。作品可以在</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">站内存储或向其他用户展示。</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">当您的身份信息和作品由您本人上传至</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">时，您同意</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">通过系统后台查阅、审核您提交的材料或信息。</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">承诺按照</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台隐私政策保护您的个人信息。</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold">2)</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold">付费文档合作：</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold">您免费上传美术作品，</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold">平台</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold"
                >可能将您自愿上传的美术作品发布至</span
              ><span
                style="
                  background-color: #e5e5e5;
                  font-family: 华文仿宋;
                  font-size: 12pt;
                  font-weight: bold;
                  text-decoration: underline;
                "
                >第三方互联网平台或者移动互联网平台</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold"
                >，按照该第三方平台的定价向该第三方平台的用户付费提供美术作品。用户付费产生的收益，在扣除</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold">平台</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold"
                >的成本后按本合同约定的分成比例与您分配。</span
              >
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">您的具体收益条款为</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">:</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">您分得的收益</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">=</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">作品售出成交金额</span
              ><span style="font-family: Arial; font-size: 12pt">×</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">30</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">%</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">分成</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold; text-decoration: underline"
                >上述收益数据以</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold; text-decoration: underline"
                >M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold; text-decoration: underline"
                >平台统计</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold; text-decoration: underline"
                >的</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold; text-decoration: underline"
                >为准。</span
              >
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt; font-weight: normal">b</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: normal">）</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold">如果您不同意参加上述</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold">付费</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold">活动，请向</span
              ><span
                style="
                  background-color: #ffff00;
                  color: #111f2c;
                  font-family: 微软雅黑;
                  font-size: 10.5pt;
                  font-weight: normal;
                "
                >M Art</span
              ><span
                style="
                  background-color: #ffff00;
                  color: #111f2c;
                  font-family: 微软雅黑;
                  font-size: 10.5pt;
                  font-weight: normal;
                "
                >@mindcomic.com</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold">邮件提出退出申请。</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">c</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">）请您谨慎阅读以下条款。如您不同意以下条款，请</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">不要勾选</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">“</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">我已阅读并接受</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">”</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">按钮</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">，或者在勾选后</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">邮件提出退出申请</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">。</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span
                style="
                  background-color: #e5e5e5;
                  font-family: 华文仿宋;
                  font-size: 12pt;
                  font-weight: bold;
                  text-decoration: underline;
                "
                >您的美术作品是否发布至第三方平台获取收益，取决于第三方平台与</span
              ><span
                style="
                  background-color: #e5e5e5;
                  font-family: 华文仿宋;
                  font-size: 12pt;
                  font-weight: bold;
                  text-decoration: underline;
                "
                >M Art</span
              ><span
                style="
                  background-color: #e5e5e5;
                  font-family: 华文仿宋;
                  font-size: 12pt;
                  font-weight: bold;
                  text-decoration: underline;
                "
                >平台</span
              ><span
                style="
                  background-color: #e5e5e5;
                  font-family: 华文仿宋;
                  font-size: 12pt;
                  font-weight: bold;
                  text-decoration: underline;
                "
                >的商业合作、市场环境、用户需求、监管政策等多种因素。</span
              >
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span
                style="
                  background-color: #e5e5e5;
                  font-family: 华文仿宋;
                  font-size: 12pt;
                  font-weight: bold;
                  text-decoration: underline;
                "
                >M Art</span
              ><span
                style="
                  background-color: #e5e5e5;
                  font-family: 华文仿宋;
                  font-size: 12pt;
                  font-weight: bold;
                  text-decoration: underline;
                "
                >平台</span
              ><span
                style="
                  background-color: #e5e5e5;
                  font-family: 华文仿宋;
                  font-size: 12pt;
                  font-weight: bold;
                  text-decoration: underline;
                "
                >不担保您的作品一定会发布至第三方平台，也不担保您的收益。</span
              >
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span
                style="
                  background-color: #e5e5e5;
                  font-family: 华文仿宋;
                  font-size: 12pt;
                  font-weight: bold;
                  text-decoration: underline;
                "
                >若您的美术作品没有在第三方平台发布，或虽已发布但未获得收益，均不视为</span
              ><span
                style="
                  background-color: #e5e5e5;
                  font-family: 华文仿宋;
                  font-size: 12pt;
                  font-weight: bold;
                  text-decoration: underline;
                "
                >M Art</span
              ><span
                style="
                  background-color: #e5e5e5;
                  font-family: 华文仿宋;
                  font-size: 12pt;
                  font-weight: bold;
                  text-decoration: underline;
                "
                >平台</span
              ><span
                style="
                  background-color: #e5e5e5;
                  font-family: 华文仿宋;
                  font-size: 12pt;
                  font-weight: bold;
                  text-decoration: underline;
                "
                >违反本协议的约定。</span
              >
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">4.2 </span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台与您的财务结算每月进行一次。</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">每月的</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; text-decoration: underline"></span
              ><span style="font-family: 华文仿宋; font-size: 12pt; text-decoration: underline">10</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; text-decoration: underline"> </span
              ><span style="font-family: 华文仿宋; font-size: 12pt">日前（遇法定节假</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">日顺延），</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台将双方各自的收益金额数据提供给您</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">。经</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台与您对账后</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">15</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">个工作日内，</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台自行将您的收益金额划账到您的结算账户。</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold"
                >平台代扣代缴您收益的个人所得税。</span
              >
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">4.3 </span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >您须确保您的结算账户的真实性及有效性。如您的：银行账户信息、银行账号、开户行、开户名称在双方合同履行过程中发生变更，您应在线上进行完善和变更结算账户的相关信息。</span
              >
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">4.4 </span
              ><span style="font-family: 华文仿宋; font-size: 12pt">您应当配合</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >办理个人所得税代扣代缴工作，并配合提供您本人的收款信息和及时确认账单。当您收到</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >的书面结算通知之日起五个工作日内未配合提供相关材料或未及时回复的，当期收益顺延至下一期结算，以此类推。</span
              >
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">如您持续保持沉默或不予配合</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">的结算或支付工作的，</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">不承担未能按本合同约定向您支付分成收益的一切</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">责任。</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">4</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">.5</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">如您上传的作品或您的行为给</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">造成损失的，</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">有权用未支付的分成款用于抵偿</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">遭受的损失。本项的约定不意味着</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">免除您承担其他赔偿或补偿责任。</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">4</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">.6</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">自本协议生效后，您在</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台免费提供</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">的</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">美术作品，</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">有权将您依据本协议授予</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">的权利转授权第三人</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">。</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">五、合作的申请和开通</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">5.1 </span
              ><span style="font-family: 华文仿宋; font-size: 12pt">服务申请方式：</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt; font-weight: normal">（</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: normal">1</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: normal"
                >）您通过线上申请开通本业务，提供相应的身份证明、权属证明、</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: normal">原创声明</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: normal"
                >等资料，通过注册程序阅读本协议并全部勾选</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: normal">”</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: normal">我已阅读并接受</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: normal">”</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: normal"
                >按钮视为您完全接受本协议。</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold"
                >如您对本协议有任何异议，请不要勾选</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold">“</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold">我已阅读并接受</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold">”</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold">按钮。</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">5.2 </span
              ><span style="font-family: 华文仿宋; font-size: 12pt">您申请使用</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台服务，必须同时满足以下条件：</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">（</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">1</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >）您是自然人，需持有中华人民共和国有效身份证件和其他</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">要求您提供的证明材料；</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">（</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">2</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">）您确认完全同意《</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold; text-decoration: underline"
                >M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold; text-decoration: underline"
                >平台服务协议</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">》，自愿受其约束，并注册成为</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台个人认证用户；</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">（</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">3</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">）提交了上述第（</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">1</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">）项约定的相关证明材料并获得</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台认可。</span
              ><span style="width: 13.5pt; text-indent: 0pt; display: inline-block"></span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">5.3 </span
              ><span style="font-family: 华文仿宋; font-size: 12pt">合作将在以下条件满足后五（</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">5</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">）个工作日内开通：</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">（</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">1</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >）您在线上申请注册，线上提交相关文件并且对线上协议全部勾选</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">”</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">我已阅读并接受</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">”</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">按钮视为您完全接受本协议；</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">（</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">2</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">）</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台未发出拒绝合作的通知。</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">5.4 </span
              ><span style="font-family: 华文仿宋; font-size: 12pt">如您在本协议生效后二十（</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">20</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">）个工作日内仍未满足本条第</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">2</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">款服务开通条件，或</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台因任何原因告知您拒绝提供服务，则</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台有权不予开通服务，本协议即告终止。</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">5.5 </span
              ><span style="font-family: 华文仿宋; font-size: 12pt">本协议约定的服务开通后，</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台将按照本协议的约定为您提供</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台及相关服务，以便您</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold">有机会</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">通过该平台发布</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">美术</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">作品</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">并由机会获得分成收益</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">。</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >平台有权根据业务需要或网站维护等原因对服务提供方式进行修改、调整，或因服务升级或系统维护等原因中止服务。</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台将在此等修改、调整或中止前通知您。</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">六、所有权与知识产权</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">6.1 </span
              ><span style="font-family: 华文仿宋; font-size: 12pt">漫图</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >保留对以下各项内容、信息完全的、不可分割的所有权及知识产权</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">:</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">（</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">1</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">）</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >平台及其所有组成元素，包括但不限于所有内容、数据、技术、软件、代码、用户界面以及与其相关的任何衍生作品；</span
              >
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">（</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">2</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">）您向</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台提供的与该平台服务相关的任何信息及反馈（</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold; text-decoration: underline"
                >不包含您向</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold; text-decoration: underline"
                >ZP</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold; text-decoration: underline"
                >ACE</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold; text-decoration: underline"
                >平台提供的</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold; text-decoration: underline"
                >美术</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold; text-decoration: underline"
                >作品</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">）。</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">七、您的权利与义务</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">7.1 </span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >您保证拥有所提供美术作品的完整版权与有效授权，有权授权</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台在</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">美术作品</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">以本协议约定的方式使用授权作品。</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">（</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">1</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >）对于非您自有权利的美术作品，您应当获得权利人的有效授权，确保您有权通过</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >平台上传、复制、传输、通过信息网络传播、推广该等美术作品。您确保您获得的授权可以使</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台合法地</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">在站内或向站外第三人</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">推广和按</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >约使用美术作品。您应自行向权利人支付可能存在的许可费用、版税以及其它应缴费用以获取权利人的有效授权。</span
              >
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">（</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">2</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">）</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold; text-decoration: underline"
                >对于您自有权利的美术作品，您签署本协议即代表您</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold; text-decoration: underline"
                >同意</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold; text-decoration: underline"
                >通过</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold; text-decoration: underline"
                >M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold; text-decoration: underline"
                >平台推广和按约使用美术作品，包括但不限于将美术作品上传、存储于</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold; text-decoration: underline"
                >M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold; text-decoration: underline"
                >平台提供的存储空间和通过</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold; text-decoration: underline"
                >M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold; text-decoration: underline"
                >平台进行信息网络传播等。</span
              >
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">7.2 </span
              ><span style="font-family: 华文仿宋; font-size: 12pt">您保证您所提供的全部作品（包括作品图片、</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">底稿</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">、</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">作品组成部分</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">等）及在</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >平台上传的全部信息符合中国法律、法规及国家政策的规定，不含任何违法、违规内容。</span
              >
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt; font-weight: normal">7.3 </span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: normal">您授予</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: normal">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: normal">平台拥有</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: normal"
                >全部授权作品及相关信息的信息网络传播权</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold; text-decoration: underline"
                >及转授权权利</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: normal">。根据上述授权，</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: normal">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: normal"
                >平台有权将您授权使用的美术作品基于互联网或无线互联网在</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: normal">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: normal">平台</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold">及其它</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold">第三方平台</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: normal">进行传播或推广。</span
              ><span
                style="
                  background-color: #e5e5e5;
                  font-family: 华文仿宋;
                  font-size: 12pt;
                  font-weight: bold;
                  text-decoration: underline;
                "
                >其他第三方平台的用户在付费或按第三方平台规则获取作品（如会员免费获取）后，使用您的作品无需另行征得您的同意或许可。</span
              >
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">7.4 </span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >您保证本协议的签署和履行并不侵犯任何第三方权益，也不会被任何第三方追索；您保证提供的美术作品不存在任何权利瑕疵，没有侵犯任何第三方的合法权益；您对所提供美术作品资源内容的真实性、准确性、完整性、合法性等负完全责任；如</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >平台被第三方主张权利而产生任何纠纷、仲裁、诉讼，或遭到国家相关部门处理，由您出面解决，承担全部法律责任并使</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台免责，并赔偿因上述原因给</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台造成的全部直接和间接损失。</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">7.5 </span
              ><span style="font-family: 华文仿宋; font-size: 12pt">若您提供的美术作品侵犯第三人权利</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">或收</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">到第三人投诉</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">的</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">，</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">有权先行下架处理（如该美</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >术作品已在第三方平台商上架的，第三方平台也先行下架）。</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">会及时通知您争议问题，</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">您应在收到</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台通知后</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">3</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">日内向</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >平台提供您为权利人的证明材料，包括但不限于个人身份证明、美术作品权属证明；若您无法证明，</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台将追回您在</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台售卖美术作品的所得，</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">永久</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">删除涉事美术作品且取消您的账户认证。</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">7.6 </span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >您应妥善保管自己的服务账户及密码信息，因您自身原因丢失账户、密码或其他重要信息等，您自行承担一切不利后果。严禁您以任何形式擅自转让或授权他人使用自己的服务账户，一经发现，</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">ZPA</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">CE</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >平台有权立即封禁该服务账户，并有权终止向您提供本协议约定的服务而无须承担违约责任。</span
              >
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">7.7</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">未经</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台事先书面同意，您不得使用</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >平台的名义进行本协议规定的目的之外任何的商业活动或任何可能对</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台的品牌造成不利影响的活动。</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">7.8 </span
              ><span style="font-family: 华文仿宋; font-size: 12pt">未经</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台事先书面许可，</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; text-decoration: underline">您不得擅自删除已向</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; text-decoration: underline">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; text-decoration: underline"
                >平台提供的授权美术作品，不得随意修改美术作品内容。</span
              >
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">7.10 </span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >如因您提供给的美术作品的版权到期或您权利授权方原因等导致该美术作品需要下线的，您应提前</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">30</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">天以书面形式通知</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台后，方可对相应美</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">术作品进行下线处理。</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">7.11 </span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >如您未根据本协议约定提交授权美术作品的版权证明文件或授权文件，或者您提供的版权证明文件或授权文件不符合</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台要求，您不得将相应作品上传到</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台，</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >平台有权拒绝您上传并对相应美术作品直接予以下线处理。</span
              >
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">7.12 </span
              ><span style="font-family: 华文仿宋; font-size: 12pt">如果</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >将您的美术作品在第三方平台向付费用户提供并开始向您支付收益后</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">，</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">您</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">有义务保持一定频率的美术</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >作品内容上传与更新。如您的美术作品长期无更新，无法满足用户对内容的使用需求，则</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >平台有权终止此协议下的合作，但应提前与您进行协商。</span
              >
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">八、</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台的权利与义务</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">8.1 </span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台负责对您授权作品及相关信息在</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >平台及其它展示终端上的运营业务提供相关的技术支持与维护服务。</span
              >
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">8.2 </span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台可以根据国家法律法规及相关政策的规定，制定</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台各项管理制度，对您授权美术作品在</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >平台的上传、存储、通过信息网络传播、使用等行为进行规范；同时，对于违反国家法律、法规、规范性</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">文件规定及其他不符合</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台要求的美术作品，</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台有权禁止该作品在</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台或其它</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">第三方平台</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">上进行发布或展示。</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">8.3 </span
              ><span style="font-family: 华文仿宋; font-size: 12pt">出于宣传或推广的目的，</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >平台有权在授权范围内免费使用您的美术作品的片段（不超过原作品内容的</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">50%</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">）、作品名称、作品封面、作品插图等，并</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">转授权第三人</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">对您的美术作品进行全文内容检索。同时，</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台可为履行本协议目的，在</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >平台和其他媒介使用您的商标、标识等知识产权，以说明您参与本协议的情况。</span
              >
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">8.4 </span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >对于第三方侵犯本协议项下美术作品的侵权行为，您授权</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">Z</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">PACE</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >平台有权独立采取包括但不限于诉讼、仲裁等各种法律手段维护自身的合法权益并获取相应收益，维权行为所发生的费用由</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台独自承担。</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">8.5 </span
              ><span style="font-family: 华文仿宋; font-size: 12pt">由于您与第三方就美术作品版权出现争议导致</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台必须对该作品下线的，</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >平台可予以配合，但您应承担由此产生的全部责任以及给</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台造成的全部损失。</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">8.6 </span
              ><span style="font-family: 华文仿宋; font-size: 12pt">如您的美术作品或相关业务违反本协议约定，或造成</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台系统严重负担，或不符合</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台相关制度规则，或其他有损</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台利益的，</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >平台有权不予上线或通知您移除相关内容，您应在接到通知后立刻移除，</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >平台也可以不经通知自行移除美术作品，无需承担任何违约责任。</span
              >
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">8.7 </span
              ><span style="font-family: 华文仿宋; font-size: 12pt">本协议到期后，如您并未主动下线或删除</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台上的美术作品，视为您授权</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >平台在平台上继续按本协议约定的方式使用其美术作品，授权期</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >限直至您主动删除或下线美术作品为止。但如您想继续按照协议约定获取收益，则应在协议到期前</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">30</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">天与</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台完成新协议的签订。</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">九、隐私</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">9.1 </span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >在收集、使用、共享或存储与任何用户相关的所有数据（包括但不限于任何用户信息）时，</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >您同意实施并遵守所适用的隐私和保密标准，这些标准至少与</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >平台隐私政策中阐明的标准同等严格和对用户有利。</span
              >
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">9.2 </span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >为保护用户的隐私，并使用户能够控制对其数据隐私设置的访问，禁止您将其访问或收集的与</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >平台用户相关的任何数据提供给任何第三方。您据此同意遵守并且不以任何方式避开由</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >平台设定的所有此类数据访问限制和用户选择的任何隐私设置。</span
              >
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">9.3 </span
              ><span style="font-family: 华文仿宋; font-size: 12pt">在</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台提出要求时，您应立即向</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台提供相关用户信息，以便：</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">(1)</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">保护或维护</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台或其员工、代理商等的合法权利或财产；</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">(2)</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">保护</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >平台服务的用户或公众的安全（包括在紧急情况下采取相应措施）；</span
              >
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">(3)</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">防止欺诈行为或实现风险管理目的；</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">(4)</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">执行相关政府主管部门的要求、规定、命令等；</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">(5)</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">遵守法律或法定程序</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span
                style="
                  background-color: #e5e5e5;
                  font-family: 华文仿宋;
                  font-size: 12pt;
                  font-weight: bold;
                  text-decoration: underline;
                "
                >9</span
              ><span
                style="
                  background-color: #e5e5e5;
                  font-family: 华文仿宋;
                  font-size: 12pt;
                  font-weight: bold;
                  text-decoration: underline;
                "
                >.4 </span
              ><span
                style="
                  background-color: #e5e5e5;
                  font-family: 华文仿宋;
                  font-size: 12pt;
                  font-weight: bold;
                  text-decoration: underline;
                "
                >特别地，如果</span
              ><span
                style="
                  background-color: #e5e5e5;
                  font-family: 华文仿宋;
                  font-size: 12pt;
                  font-weight: bold;
                  text-decoration: underline;
                "
                >M Art</span
              ><span
                style="
                  background-color: #e5e5e5;
                  font-family: 华文仿宋;
                  font-size: 12pt;
                  font-weight: bold;
                  text-decoration: underline;
                "
                >平台</span
              ><span
                style="
                  background-color: #e5e5e5;
                  font-family: 华文仿宋;
                  font-size: 12pt;
                  font-weight: bold;
                  text-decoration: underline;
                "
                >将您的美术作品发布至第三方平台供付费用户使用时，为了保护您的著作权，</span
              ><span
                style="
                  background-color: #e5e5e5;
                  font-family: 华文仿宋;
                  font-size: 12pt;
                  font-weight: bold;
                  text-decoration: underline;
                "
                >M Art</span
              ><span
                style="
                  background-color: #e5e5e5;
                  font-family: 华文仿宋;
                  font-size: 12pt;
                  font-weight: bold;
                  text-decoration: underline;
                "
                >平台</span
              ><span
                style="
                  background-color: #e5e5e5;
                  font-family: 华文仿宋;
                  font-size: 12pt;
                  font-weight: bold;
                  text-decoration: underline;
                "
                >有权向第三方平台披露您的姓名（或笔名），用以指明作者的身份。如果您提供的美术作品涉及知识产权纠纷的，</span
              ><span
                style="
                  background-color: #e5e5e5;
                  font-family: 华文仿宋;
                  font-size: 12pt;
                  font-weight: bold;
                  text-decoration: underline;
                "
                >M Art</span
              ><span
                style="
                  background-color: #e5e5e5;
                  font-family: 华文仿宋;
                  font-size: 12pt;
                  font-weight: bold;
                  text-decoration: underline;
                "
                >平台</span
              ><span
                style="
                  background-color: #e5e5e5;
                  font-family: 华文仿宋;
                  font-size: 12pt;
                  font-weight: bold;
                  text-decoration: underline;
                "
                >披露您提供的权利证明（含身份证明），不视为</span
              ><span
                style="
                  background-color: #e5e5e5;
                  font-family: 华文仿宋;
                  font-size: 12pt;
                  font-weight: bold;
                  text-decoration: underline;
                "
                >M Art</span
              ><span
                style="
                  background-color: #e5e5e5;
                  font-family: 华文仿宋;
                  font-size: 12pt;
                  font-weight: bold;
                  text-decoration: underline;
                "
                >平台</span
              ><span
                style="
                  background-color: #e5e5e5;
                  font-family: 华文仿宋;
                  font-size: 12pt;
                  font-weight: bold;
                  text-decoration: underline;
                "
                >侵犯您的人格权和个人信息。</span
              >
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">十、信息披露与保密</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">10.1 </span
              ><span style="font-family: 华文仿宋; font-size: 12pt">您与</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >平台重大信息的披露、采用、表述等均应获得双方的一致认可。您可以宣传</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">您与</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">就美术作品开展商业合作</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">的事实与情况，但未经过</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台事先书面同意，不得发布使用任何含有</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台名称、商标、</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">logo</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >、标记等的新闻稿、其他宣传声明或推广材料。出于宣传或推广</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">目的，</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台有权发布、提及或描述</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">您授权的</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">美术作品或您</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">提交</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">的宣传和推广材料。</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">10.2 </span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >平台或您对于因签署或履行本协议而了解或接触到的对方的商业秘密及其他保密资料和信息（以下简称</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">"</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">保密信息</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">"</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >）均应保守秘密。除非国家法律法规、政府或者法院的要求，或者本协议双方同意，任何一方不得向任何第三方泄露、给予或转让该等保密信息。除为实现本协议项下约定之目的所必须外，未经对方事先书面同意，任何一方不得擅自使用、复制或擅自向任何第三方授权使用、授权复制对方的商标、标志、商业信息、技术及其他资料等。</span
              >
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">10</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">.3 </span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >本保密条款不因本协议的无效、被撤销、解除、提前终止、不具操作性等而</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">失效。</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">十一、免责声明</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">11.1 </span
              ><span style="font-family: 华文仿宋; font-size: 12pt">本协议项下</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >平台将在现有技术的基础上尽最大努力提供相应的安全措施以保障服务安全和正常运行。但</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >平台明确声明对服务不作任何明示或暗示的保证，包括但不限于对服务的安全性、可靠性、持续性、准确性、适用于某一特定用途等。您签署本协议即意味着理解且不要求</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台在以下任一情况下承担责任：</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">（</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">1</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >）不可抗力。不可抗力是指本协议双方不能合理控制、不可预见或即使预见亦无法避免的事件，包括但不限于</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >政府行为、地震、台风、洪水、火灾或其它天灾、战争或任何其它类似事件。</span
              >
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">（</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">2</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >）鉴于互联网之特殊性质，不可抗力亦包括但不限于下列影响互联网正常运行之情形：</span
              >
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">（</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">a</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">）黑客攻击；</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">（</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">b</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">）电信部门技术调整导致之重大影响；</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">（</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">c</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">）因政府管制而造成之暂时关闭；</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">（</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">d</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">）病毒侵袭；</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">（</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">e</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >）网站升级、系统停机维护或通讯终端、电信设备出现故障导致无法进行数据传输；</span
              >
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">（</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">f</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >）其他非因双方原因导致互联网无法正常运行、服务中断或延迟之情形。</span
              >
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">（</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">3</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >）如发生不可抗力事件，遭受该事件的一方应立即以可能的最快捷的方式通</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >知另一方该事件的性质、发生日期、预计持续时间等有关细节，以及该事件阻碍通知方履行其于本协议项下义务的程度。</span
              >
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">（</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">4</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >）在不可抗力事件持续期间，遭受不可抗力事件的一方应定期及时地告知另一方不可抗力事件的现状。如不可抗力事件结束，应立即以书面形式通知对方，并继续履行其于本协议项下之义务。</span
              >
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">（</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">5</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >）遭受不可抗力事件的一方应当向另一方提供事件发生地区的公证机构</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">(</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">或其他适当机构</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">)</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">出具的证实不可抗力事件的合法证明。</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">（</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">6</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">）如果不可抗力事件持续超过九十（</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">90</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">）天，任何一方均可按本协议</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">13.2</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">之规定终止本协议。</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">（</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">7</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >）本协议任何一方违约后遭遇不可抗力的，违约责任不因不可抗力而免除</span
              >
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">11.2 </span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台有权在提前通知或不通知的情况下</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">随时修改、限制、暂停或终止全部或部分</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台服务，对于此等修改、限制、暂停或终止行为，</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台对您或任何第三方不负任何责任。</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">11.3 </span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >平台及其关联公司仅向您及用户提供技术平台以便您得以向通过信息网络传播、推广其授权美术作品，不对您或</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">其他</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">用户的任何口头、书面陈述或者其向</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >平台上传的任何信息之真实性、合法性做任何担保，或对此承担任何责任。如因</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">您上传的</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">美术作品</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >存在权利瑕疵（如美术作品涉嫌抄袭、您超越原授权范围使用等情形）</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >产生纠纷的，您应以自己的名义独立承担所有法律责任。</span
              >
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">11.</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">4 </span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">仅为实现合同目的免费提供临时性的存储服务，</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">没有义务为您</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">保存其存储于</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台中的数据以及您使用</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >平台产生的任何数据。您应自行对相关数据进行定期保存。您如因数据丢失造成损失或产生其他责任，</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台均不负责承担。</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">11.5 </span
              ><span style="font-family: 华文仿宋; font-size: 12pt">在任何情况下，</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台、</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >平台及其董事、员工或代理人，均不负责对您或任何第三方就任何法定或约定之损害承担责任，即使</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >平台已经知道或已被告知发生了上述损害或上述损害发生的可能性。</span
              >
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">十二、违约责任</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">12.1 </span
              ><span style="font-family: 华文仿宋; font-size: 12pt">除本合同另有约定外，任何</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >一方违反本合同约定的，应赔偿因此给另一方造成的经济损失。</span
              >
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">12.2 </span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >因您所提供的美术作品存在权利瑕疵或侵犯任何第三方的合法权益、内容违法违规等导致</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >平台损失或陷入诉讼、争议，或者受到国家有关部门的查处或处罚，应视为您根本违约，由您出面解决并承担全部责任。同时，</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >平台有权单方解除本协议，终止提供本协议约定的服务。因此给</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台造成损失的，您应负责赔偿</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">平台的全部损失，包括直接损失与其他合理损失。</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">12.3 </span
              ><span style="font-family: 华文仿宋; font-size: 12pt">若</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >平台与您均违反本协议之约定，则应当各自承担相应的责任。</span
              >
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">十三、协议期限与终止</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">13.1 </span
              ><span style="font-family: 华文仿宋; font-size: 12pt">本协议自您勾选</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">“</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">我已阅读并确认</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">”</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >后生效，期限自协议生效之日起贰年。期满后，如您没有明确向</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >平台发出书面通知终止本协议，则本协议继续顺延，直至双方明确通过书面方式解除本协议。</span
              >
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">13.2 </span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >协议终止：发生以下任何事件时，经书面通知对方，任何一方均可立即终止本协议：</span
              >
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">（</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">1</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >）一方严重违反本协议，且对于可补救的违约，未在收到对方书面通知后三十（</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">30</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">）天内予以补救；</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">（</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">2</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">）一方严重违约致使不能实现合同目的；</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">（</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">3</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">）一方破</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >产、无力偿债、进入清算或解散程序、不再从事业务或不能清偿到期债务；</span
              >
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">（</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">4</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">）按本协议第</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">11.1</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">条之约定，不可抗力事件发生并持续超过九十（</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">90</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">）天。</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">十四、争议解决与法律适用</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">14.1 </span
              ><span style="font-family: 华文仿宋; font-size: 12pt">如</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >平台与您就本协议内容或其执行发生任何争议，双方应首先进行友好协商；若经协商无法解决该争议，则双方应将争议提交</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">广州市海珠区</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">人民法院诉讼解决。</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">14.2 </span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >本协议的订立、执行、解释及争议的解决均适用中华人民共和国法律。</span
              >
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">14.3 </span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >本协议无效、被撤销或者终止的，不影响本协议中独立存在的有关解决争议方法与法律适用等条款的效力。</span
              >
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">十五、其他事项</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">15.1 </span
              ><span style="font-family: 华文仿宋; font-size: 12pt">本协议具有合同效力。</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">15.2 </span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >由于本协议的申请和认证系全线上操作，协议打印件有效。</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"> </span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">15.3 </span
              ><span style="font-family: 华文仿宋; font-size: 12pt">若依本协议发生相关诉讼，您应向</span
              ><span style="font-family: 华文仿宋; font-size: 12pt">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"
                >平台提供纸质版权属证明及授权文件的原件及复印件。</span
              ><span style="font-family: 华文仿宋; font-size: 12pt"> </span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold">版权承诺书</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold"
                >您在此郑重声明，您是所提交的美术作品的权利人，拥有或者有权管理所提交的美术作品，并且有权授权第三人合法使用。</span
              >
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold">您与</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold"
                >平台集团及其关联公司（以下简称</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold">"</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold">平台</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold">"</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold">），在</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold">平台</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold">合作</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold"
                >过程中，严格遵守国家法律、法规、部门规章、政策规定，以及</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold"
                >平台相关的协议、业务流程及其他管理规定，并承诺：</span
              >
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold">&#xa0;</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold"
                >一、您对所提供的所有美术作品拥有其原始版权或专有许可权或非专有许可权，</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold"
                >拥有充分、完整、合法的权利，有权对所提交的美术作品进行许可和授权，不侵犯作品权利人以及任何第三方的合法权益，包括但不限于著作权、其他知识产权或其他合法权益。</span
              >
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold"
                >二、您对所提供美术作品资源内容的真实性、准确性、完整性、合法性等负完全责任。</span
              >
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold"
                >三、您所提供的美术作品均在合法有效期内。</span
              >
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold">四、您</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold"
                >保证对所有因您提供的美术作品所造成的法律纠纷和责任，包括但不限于因文件资料和证明材料的真实性、合法性和有效性，以及超越权利范围和期限等原因造成的纠纷、行政调查和处罚等责任概由您承担，</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold"
                >平台作为开放平台不承担责任。</span
              >
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold"
                >五、您保证对所有因您提供的美术作品与第三方就该美术作品版权出现争议导致</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold">平台</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold"
                >必须对该作品下线的，您自行承担由此产生的全部责任以及给</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold">平台方造成的全部损失，</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold">M Art</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold"
                >平台作为开放平台不承担责任。</span
              >
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold"
                >六、若违反上述承诺所导致的任何法律责任既造成的任何损失，均由您自行承担。</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold">ZPAC</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold">E</span
              ><span style="font-family: 华文仿宋; font-size: 12pt; font-weight: bold"
                >平台作为开放平台不承担责任。</span
              >
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import tab1 from './tabs/tab1.vue'
import tab2 from './tabs/tab2.vue'
import tab3 from './tabs/tab3.vue'
import tab4 from './tabs/tab4.vue'
import tab5 from './tabs/tab5.vue'
export default {
  components: {
    tab1,
    tab2,
    tab3,
    tab4,
    tab5,
  },
  data () {
    return {
      active: '1'
    }
  },
  mounted () {
    console.log(this.$route.query.id)
    this.active = this.$route.query.id || '1'
  },
  activated () {
    console.log(this.$route.query.id)
    this.active = this.$route.query.id || '1'
  },
  computed: {
    id () {
      return this.$route.query.id
    }
  },
  methods: {
    changeActiveFunc (id) {
      console.log('changeActiveFunc', id)
    },
    change (id) {
      this.active = id
      window.scrollTo(0, 0)
    }
  },
  watch: {
    id (val) {
      this.active = val
    }
  }
}
</script>

<style lang="less" scoped>
.wrap {
  background-color: rgb(245, 245, 245);
  padding-bottom: 40px;
}
#components-box {
  position: relative;
  width: 1050px;
  margin: 0 auto 0;
  padding-top: 30px;
  padding-left: 250px;
  background-color: rgb(245, 245, 245);
}
#components-box .left {
  position: absolute;
  left: 0;
  top: 40px;
  .diy-left-side-tab {
    background-color: #ffffff;
    h3 {
      padding: 10px 0;
      text-align: center;
      font-size: 20px;
      color: #000;
    }
    .item {
      cursor: pointer;
      width: 200px;
      height: 60px;
      line-height: 60px;
      text-align: center;
      &.active {
        background-color: @primary-color;
        color: #ffffff;
      }
    }
  }
}
#components-box .right {
  padding: 15px;
  background-color: #ffffff;

}
.email-word {
    margin: 0 4px;
    display: inline-block;
    mask: url(../../assets/img/email.png) center / 100% no-repeat;
  }
</style>
